// 2024-10-07T09:50:17.822Z  (1728294617822)
export const locale = {
	lang: 'nl',
	data: {
		'ACCOUNTING_VALUE': 'Meerwaarde',
		'ACCOUNTING_VALUES': 'Toegevoegde waarde',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Berekening in status',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Waarde-aggregatie',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Waarde-berekening',
		"ACCOUNTING_VALUE.RESOURCE_TYPE": "Type operationele hulpbron",
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Waarde sommatie',
		'ACCOUNT_ACTIVATION': 'Account activering',
		'ACCOUNT_ACTIVATION.CODE': 'Activeringscode',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Activeringscode opnieuw versturen',
		'ACCOUNT_ACTIVATION.INTRO': 'Resend activation code',
		'ACID': 'Acid',
		'ACTIVATE': 'Activeren',
		'ACTIVATE.SELECTED': 'Activeer geselecteerde',
		'ACTIVE': 'Actief',
		'ACTIVITIES.DAILY': 'Dagelijkse activiteiten',
		'ACTIVITIES.EXPORT': 'Exportactiviteiten',
		'ACTIVITIES.NO': 'Geen activiteiten',
		'ACTIVITIES.WEEKLY': 'Wekelijkse activiteiten',
		'ACTIVITY': 'Activiteit',
		'ACTIVITY.EXPORT_DETAILS': 'Exporteer de geselecteerde activiteit',
		'ACTIVITY.NO_FIELDS_WORKED': 'Geen werk gedaan op bekende velden',
		'ADAPTER': 'Adapter',
		'ADAPTER.ASSIGN': 'Adapter toewijzen',
		'ADAPTER.ASSIGN.FAILURE': 'Er is een fout opgetreden bij het koppelen van de adapter.',
		'ADAPTER.ASSIGN.SUCCESS': 'Adapter succesvol toegewezen',
		'ADAPTER.ASSIGNED_MACHINE': 'Toegewezen machine',
		'ADAPTER.ASSIGNMENT': 'Toewijzing van adapters aan machines',
		'ADAPTER.CHOSEN': 'Gekozen adapter',
		'ADAPTER.LOAD.FAILURE': 'Er is een fout opgetreden bij het laden van de adapter.',
		'ADAPTER.NO': 'Geen adapter',
		'ADAPTER.NONE_AVAILABLE': 'Geen adapter beschikbaar',
		'ADAPTER.PAIR_INFO': 'Selecteer de bijbehorende adapter. Reeds toegewezen adapters worden overschreven met de nieuwe machine. De nieuwe configuratie wordt automatisch geladen bij de volgende herstart van de adapter.',
		'ADAPTER.PREVIOUS': 'Vorige adapter',
		'ADAPTERS.NO': 'Geen adapters',
		'ADBLUE.LEVEL': 'AdBlue niveau',
		'ADD': 'Toevoegen',
		'ADDITIONAL_VALUE': 'Extra waarde',
		'ADDITIVE': 'Toevoeging',
		'ADDRESS': 'Adres',
		'ALL': 'Все',
		'ALL_DEVICES': 'Algemene apparaten',
		'AMOUNT': 'Aantal',
		'AMOUNT.INVALID': 'Ongeldige aantal',
		'AMOUNTS': 'Bedragen',
		'APPLY': 'Toepassen',
		'ARCHIVE': 'Archief',
		'ARCHIVE.SELECTED': 'Archief geselecteerd',
		'AREA': 'Gebied',
		'AREA.FIELD': 'Oppervlakte',
		'AREA.LOCATION': 'Locaties',
		'AREA.PERFORMANCE': 'Gebiedsprestaties',
		'AREA.PROCESSED': 'Bewerkte oppervlakte',
		'AREA.TOTAL': 'volledige oppervlakte',
		'AREA.WORKED': 'Bewerkt gebied',
		'ASSIGN': 'Toewijzen',
		'AUTH.REMEMBER_ME': 'Onthoud mij',
		'BACK': 'terug',
		'BALES': 'Balen',
		'BASIC_DATA': 'Basis data',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Baken toewijzen',
		'BEACON.ASSIGN.SUCCESS': 'Beacon succesvol toegewezen',
		'BEACON.ASSIGNED_EMPLOYEE': 'Toegewezen medewerker',
		'BEACON.ASSIGNED_IMPLEMENT': 'Toegewezen werktuig',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Wijs Beacon toe aan medewerker',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Wijs baken toe aan werktuig',
		'BEACON.CHOSEN': 'Kies beacon',
		'BEACON.ERROR': 'Er is een fout opgetreden bij het koppelen van het beacon.',
		'BEACON.LOAD_ERROR': 'Er is een fout opgetreden bij het laden van het beacon',
		'BEACON.NONE_AVAILABLE': 'Geen beacon beschikaar',
		'BEACON.NO_BEACON': 'Geen beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Selecteer het bijbehorende beacon. Reeds toegewezen beacons worden overschreven met de nieuwe medewerker.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Selecteer het bijbehorende beacen. Reeds toegewezen beacons worden overschreven met het nieuwe werktuig.',
		'BEACON.PREVIOUS': 'Vorige beacon',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Bouwjaar',
		'BUILD_YEAR.INVALID': 'Bouwjaar ongeldig',
		'CAN.STATUS': 'CAN-status',
		'CANCEL': 'Annuleren',
		'CHANGE': 'Verandering',
		'CHANGE.NO': 'Geen verandering',
		'CHOOSE_ALL': 'Alles kiezen',
		'CHOOSE_ROLE': 'Kies een rol',
		'CHRONOLOGICAL': 'Chronologische volgorde',
		'CLICK_PROCESS': 'Selecteer een proces voor meer details',
		'CLOSE': 'Sluiten',
		'CO2.EMISSION': 'CO2-uitstoot',
		'CO2.PER': 'Aantal CO2 per ha',
		'CO2.TOTAL': 'Totaal bedrag van CO2',
		'COLOR': 'Kleur',
		'COMMENT': 'Commentaar',
		'CONDITION': 'conditie',
		'CONFIRM': 'Bevestigen',
		'CONFIRM_PASSWORD': 'Bevestig wachtwoord',
		'CONNECT': 'Aansluiten',
		'CONTACT_PERSON': 'Contactpersoon',
		'CONTINUE': 'Voortzetten',
		'COST': 'Kosten',
		'COST.INVALID': 'Kosten ongeldig',
		'COST.OVERALL': 'Totale kosten',
		'COST.OVERALL.ARRIVAL': 'Totale kosten aankomst',
		'COST.OVERALL.DRIVER': 'Totale kostendrijver',
		'COST.OVERALL.FIELD_TIME': 'Totale kosten op het veld',
		'COST.OVERALL.IMPLEMENTS': 'Totale kosten implementaties',
		'COST.OVERALL.MACHINES': 'Totale kosten machines',
		'COST.OVERALL.PREPARATION': 'Algemene kostenvoorbereiding',
		'COST.TOTAL': 'Totaal kosten',
		'COSTS': 'Kosten',
		'COST_RATE': 'Kostentarief',
		'COUNTRY': 'Land',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Dekking kaart',
		'COVERAGE.MAP.SETTINGS': 'Instellingen dekkingskaart',
		'COVERAGE.MAP.ZONES': 'Zones',
		'CREATED': 'Gemaakt',
		'CREATE_USER': 'Gebruiker aanmaken',
		"CROP": "Gewas",
		'CROP.TYPE': 'Gewas type',
		'CROP.NO_CROP': 'Geen gewas',
		'CURRENCY': 'Valuta',
		'CUSTOMER': 'Klant',
		'CUSTOMER.ADD': 'Nieuwe klant toevoegen',
		'CUSTOMER.ADD.SUCCESS': 'Klant succesvol toegevoegd',
		'CUSTOMER.ASSIGN': 'Klant toewijzen',
		'CUSTOMER.DELETE.QUESTION': 'Willt u echt de klant verwijderen?',
		'CUSTOMER.DELETE.SUCCESS': 'Klant is verwijdert',
		'CUSTOMER.DETAILS': 'Klant details',
		'CUSTOMER.EDIT': 'Klant bewerken',
		'CUSTOMER.EDIT.SUCCESS': 'Klant succesvol bewerkt',
		'CUSTOMER.NAME': 'Klantnaam',
		'CUSTOMER.NO': 'Geen klant',
		'CUSTOMER.NOT_SELECTED': 'Geen klant selecteerd',
    'CUSTOMER.NO.ASSIGNEE': 'Geen klant toewijzen',
		'CUSTOMER.SELECT': 'Selecteer klant',
		'CUSTOMERS': 'Klanten',
		'CUSTOMERS.ALL': 'Alle klanten',
		'CUSTOMERS.DELETE.FAILURE': 'Sommige klanten konden niet worden verwijderd.',
		'CUSTOMERS.DELETE.QUESTION': 'Willt u de klanten verwijderen?',
		'CUSTOMERS.DELETE.SUCCESS': 'Klanten werden succesvol verwijdert',
		'CUSTOMERS.MANAGEMENT': 'Klantenmanagement',
		'CUSTOMERS.NO': 'Geen klanten',
		'CUSTOMERS.SELECTED': 'Geselecteerde klanten',
		'CUSTOM_LABELING': 'Aangepaste labels',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Nieuwe werkstaat toevoege',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Definieer een aangepaste label voor het geselecteerde werktuig.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Definieer individuele voorwaarden voor het label.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Bewerken van aangepaste labels was succesvol',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Individuele conditie',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Overschrijven met ISOBUS-voorwaarden toestaan',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Geen labels beschikbaar',
		'DASHBOARD.GPS_DATA.NO': 'Geen gps-gegevens',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Er is een fout opgetreden bij het laden van de machineposities',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'De onderliggende gegevens zijn gedeeltelijk of volledig gearchiveerd',
		'DATA.EXPORT': 'Gegevensexport',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Onderliggende gegevens worden bijgewerkt',
		'DATA_PREPARATION': 'Data voorbereiding',
		'DATE': 'Datum',
		'DATE.APRIL': 'April',
		'DATE.AUGUST': 'Augustus',
		'DATE.DECEMBER': 'December',
		'DATE.FEBRUARY': 'Februari',
		'DATE.FRIDAY': 'Vrijdag',
		'DATE.FROM': 'Van',
		'DATE.JANUARY': 'Januari',
		'DATE.JULY': 'Juli',
		'DATE.JUNE': 'Juni',
		'DATE.MARCH': 'Maart',
		'DATE.MAY': 'Mei',
		'DATE.MONDAY': 'Maandag',
		'DATE.NOVEMBER': 'November',
		'DATE.OCTOBER': 'Oktober',
		'DATE.PERIOD': 'Periode',
		'DATE.RANGE': 'Datumbereik',
		'DATE.SATURDAY': 'Zaterdag',
		'DATE.SEPTEMBER': 'September',
		'DATE.SUNDAY': 'Zondag',
		'DATE.THURSDAY': 'Donderdag',
		'DATE.TUESDAY': 'Dinsdag',
		'DATE.UNTIL': 'Tot',
		'DATE.WEDNESDAY': 'Woensdag',
		'DAY.CURRENT': 'Huidige dag',
		'DAY.NEXT': 'Volgende dag',
		'DAY.PREVIOUS': 'Vorige dag',
		'DAY.SELECTED': 'Geselecteerde dag',
		'DAYS': 'Dagen',
		'DAY_ACTIVITIES': 'Dagelijke activiteiten',
		'DEACTIVATE': 'Deactiveer medewerkers',
		'DEACTIVATE.SELECTED': 'Selectie deactiveren',
		'DEADLINE': 'Deadline',
		'DEADLINE.ADD': 'Deadline toevoegen',
		'DEADLINE.ADD.SUCCESS': 'Deadline succesvol toegevoegd',
		'DEADLINE.DELETE.SUCCESS': 'Deadline succesvol verwijdert',
		'DEADLINE.DONE': 'Eind',
		'DEADLINE.DUE': 'Deadline ten gevolge',
		'DEADLINE.DUE_IN_AT': 'Ten volge in/bij',
		'DEADLINE.EDIT': 'Deadline bewerken',
		'DEADLINE.EDIT.SUCCESS': 'Deadline is gewijzigd',
		'DEADLINE.IS_CLOSE': 'Deze deadline komt eraan',
		'DEADLINE.IS_OVERDUE': 'Deze deadline is al geweest',
		'DEADLINE.OPEN': 'Open',
		'DEADLINE.PROCESS.SUCCESS': 'Deadline succesvol verwerkt',
		'DEADLINE.PROCESSED': 'Verwerkt',
		'DEADLINE.PROCESSED.SUCCESS': 'Deadline succesvol verwerkt',
		'DEADLINE.WARN': 'Deadline komt eraan',
		'DEADLINES': 'Deadlines',
		'DEADLINES.NO': 'Geen deadlines',
		'DEFINE_ROLE': 'Definieer de rol',
		'DELETE': 'Verwijderen',
		'DELETE.SELECTED': 'Geselecteerde verwijderen',
		'DELETED': 'Verwijderd',
		'DESCRIPTION': 'Beschrijving',
		'DIAGRAM': 'Diagram',
		'DISPLAY': 'Scherm',
		'DISPLAY_TRACK': 'Scherm track',
		'DISTANCE': 'Afstand',
		'DISTANCE.TOTAL': 'Totale afstand',
		'DISTANCE.WORKED': 'Werkafstand',
		'DOWNLOAD': 'Download',
		'DRIVER': 'Bestuurder',
		'DRIVER.EDIT': 'Stuurprogramma bewerken',
		'DRIVER.FIXED': 'Vaste bestuurder',
		'DRIVER.NO': 'Geen bestuurder',
		'DRIVER.REMOVE': 'Stuurprogramma verwijderen',
		'DRIVERS': 'Bestuurders',
		'DRIVERS.ALL': 'Alle bestuurders',
		'DRIVER_SCAN_DISABLED': 'Bestuurder beacon-scan inactief',
		'DURATION': 'Looptijd',
		'DURATION.WORKED': 'Werkduur',
		'EDIT': 'Bewerk',
		'EDIT.SELECTED': 'Bewerk geselecteerde',
		'EDIT_USER': 'Bewerk gebruiker',
		'EMAIL': 'Contact email',
		'EMAIL.ACTIVATE': 'Activeer e-mail',
		'EMAIL.ACTIVATE.CODE': 'Activatie code',
		'EMAIL.ACTIVATE.EXPLANATION': 'Als u uw e-mailadres hebt gewijzigd, sturen we een activeringscode naar u nieuwe adres.',
		'EMAIL.CHANGE': 'E-mail veranderen',
		'EMAIL.CHANGE.SUCCESS': 'E-mail succesvol verandert',
		'EMAIL.CONFIRM': 'Bevestig e-mail',
		'EMAIL.CURRENT': 'Actuele e-mail',
		'EMAIL.INVALID': 'E-mail ongeldig',
		'EMAIL.NEW': 'Nieuwe e-mail',
		'EMAIL.NO_MATCH': 'Emails komen niet overeen',
		'EMPLOYEE': 'Medewerker',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Wilt u de medewerker echt activeren?',
		'EMPLOYEE.ADD': 'Medewerker toevoegen',
		'EMPLOYEE.ADD.SUCCESS': 'Medewerker succesvol toegevoegd',
		'EMPLOYEE.CREATE': 'Medewerker creëren',
		'EMPLOYEE.CREATE.SUCCESS': 'Medewerker succesvol aangemaakt',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Wilt u de medewerker echt deactiveren?',
		'EMPLOYEE.DELETE.QUESTION': 'Wilt u de medewerker echt verwijderen?',
		'EMPLOYEE.EDIT': 'Bewerk medewerker',
		'EMPLOYEE.EDIT.SUCCESS': 'Medewerker succesvol bewerkt',
		'EMPLOYEE.ROLE': 'Rol van de medewerker',
		'EMPLOYEE.ROLE_OF': 'Rol van de medewerker',
		'EMPLOYEES': 'Medewerkers',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Wil je de werknemers echt activeren?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Medewerkers succesvol geactiveerd',
		'EMPLOYEES.ALL': 'Alle medewerkers',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Sommige medewerkers konden niet worden geactiveerd',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Wilt u de geselecteerde medewerkers echt deactiveren?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Medewerkers zijn deactiveerd',
		'EMPLOYEES.DELETE.FAILURE': 'Sommige medewerkers konden niet verwijdert worden',
		'EMPLOYEES.DELETE.QUESTION': 'Wilt u echt de geselecteerde medewerkers verwijderen?',
		'EMPLOYEES.DELETE.SUCCESS': 'Medewerkers verwijdert',
		'EMPLOYEES.MANAGEMENT': 'Medewerkers management',
		'EMPLOYEES.NO': 'Geen medewerkers',
		'EMPLOYEES.NOT_SELECTED': 'Geen medewerkers geselecteerd',
		'EMPLOYEES.SELECTED': 'Geselecteerde medewerkers',
		'EMPLOYER.NO': 'Geen werkgever',
		'EMPLOYER.NOT_SELECTED': 'Geen werkgever geselecteerd',
		'EMPLOYES.NO': 'geen medewerkers',
		'END_DRAW_MODE': 'Tekenmodus geannuleerd',
		'ENTERPRISE': 'Onderneming',
		'ENTERPRISE.ADD': 'Onderneming toevoegen',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'U moet een werkgever toevoegen',
		'ENTERPRISE.ADDED.SUCCESS': 'Bedrijf succesvol toegevoegd',
		'ENTERPRISE.ADD.SUCCESS': 'Succesvol onderneming toegevoegd',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Voer de toegangscode voor de onderneming in.',
		'ENTERPRISE.NAME': 'Ondernemingsnaam',
		'ENTERPRISE.NOT_SELECTED': 'Geenn onderneming geselecteerd',
		'ENTERPRISE.OF': 'Onderneming van:',
		'ENTERPRISE.SETTINGS': 'Onderneming-instellingen',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Enterprise-configuratie succesvol bijgewerkt',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Machines succesvol gesynchroniseerd',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Werknemerslicenties',
		'ENTERPRISE_LICENSE.LICENSE': 'Лицензия',
		'ENTERPRISE_LICENSE.MACHINE': 'Machine licentie',
		'ENTERPRISE_LICENSE.MACHINES': 'Machine licenties',
		'ENTERPRISE_MIN': 'De ondernemingsnaam moet minimaal 3 tekens bevatten',
		'ENTERPRISE_NAME_REQUIRED': 'Ondernemingsnaam benodigd',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Onderneming toevoegen',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licentie verlopen',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Testaccount aanvragen',
		'ENTERPRISE_STATISTICS': 'Enterprise-statistieken',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Kosten diagram',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Procesverdeling',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Alles',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Werken / transporteren',
		'ENUM.ACCOUNTING_MODE.AVG': 'Gemiddelde',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maximaal',
		'ENUM.ACCOUNTING_MODE.MED': 'Mediaan',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimum',
		'ENUM.ACCOUNTING_MODE.SUM': 'Som',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Absoluut verschil',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Direct',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Negatief verschil',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Positive  verschil',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Tijd actief',
		'ENUM.BEACONTYPE.BDrv': 'Маячок для водителя',
		'ENUM.BEACONTYPE.BImpl': 'Baken implementeren',
		'ENUM.CAN_IDENTIFIER.A1': 'Analoog 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Analoog 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Analoog 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Analoog 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'Load sensing \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'Load sensing \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'I. Besturingseenheid\"+\"',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'I. Besturingseenheid\"-\"',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'II. Besturingseenheid\"+\"',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'II. Besturingseenheid\"-\"',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'III. Besturingseenheid\"+\"',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'III. Besturingseenheid \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'IV. Besturingseenheid\"+\"',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'IV. Besturingseenheid\"-\"',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'IO-Box: gemiddelde hoek 1',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'IO-Box: hoek 1 max.',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'IO-Box: hoek 1 min.',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'IO-Box: gemiddelde hoek 2',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'IO-Box: hoek 2 max.',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'IO-Box: hoek 2 min',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'IO-Box: gemiddelde hoek 3',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'IO-Box: hoek 3 max.',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'IO-Box: hoek 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Toegepast zuur',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Toegepaste additieven',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Toegepaste drijfmest',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Asgewicht 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Asgewicht 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Teller 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Teller 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Hakker',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Unimog: Status Besturingseenheid 1',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Unimog: Status Besturingseenheid 2A',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Unimog: Status Besturingseenheid 2A',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Unimog: Status Besturingseenheid 3',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Unimog: Status Besturingseenheid 4',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Unimog: Slipkoppeling',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Snijgeleider',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'SnijgeleiderP',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Snijder positie',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Status Snij-eenheid',
		'ENUM.CAN_IDENTIFIER.D1': 'IO-Box: Digital 1',
		'ENUM.CAN_IDENTIFIER.D2': 'IO-Box: Digital 2',
		'ENUM.CAN_IDENTIFIER.D3': 'IO-Box: Digital 3',
		'ENUM.CAN_IDENTIFIER.D4': 'IO-Box: Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Rijhendel',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'AdBlue-niveau',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Brandstofniveau',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Brandstof tarief',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Motor snelheid',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Draaimoment',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Positie van de voorste takel',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Aftakas vooraan actief',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Aftakassnelheid vooraan',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Straat- / veldschakelaar',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Straat- / veldschakelaar 2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Trekkracht aan de voorkant',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Ontwerp (nominaal) front',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Richting (op de grond)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Snelheid over de grond',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Snelheid gps',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Geselecteerde versnelling',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Graan transporterende positie',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Vulniveau graantank',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'Unimog: rijrichting hydrostatisch',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'Unimog: status hydrostatisch',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Werkstatus implementeren',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Job actief',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Snelheid motor (links)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Koppel motor (links)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Snelheid motor (rechts)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Koppel motor (rechts)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'geen waard',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolute',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE относительно',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'SyreN: drijfmest pH-waard',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Unimog: PTO-schakelaar',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Unimog: PTO-schakelaar 1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Unimog: PTO-schakelaar 2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'SyreN: NUE relatief',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Nabijheids sensor',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Positie achterste takel',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'Achterste aftakas actief',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Aftakastoerental achter',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Trekkracht aan de achterkant',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Nominale trekkracht aan de achterzijde',
		'ENUM.CAN_IDENTIFIER.Roll': 'Roltarief',
		'ENUM.CAN_IDENTIFIER.Sli': 'Slip',
		'ENUM.CAN_IDENTIFIER.Spe': 'snelheid',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Positie strahakselaar',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Status dorstrommel',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Bandenspanning links A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Bandenspanning links A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Bandenspanning rechts A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Bandenspanning rechts A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'Status losvijzel',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Richting van het reiswiel',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Snelheid op wielen',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Versnelling X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Versnelling y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Giertarief',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Opbrengst gewas',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Vochtig gewas',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Versnelling Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£ ',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Beheerder',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consultant',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Verzender',
		'ENUM.EMPLOYEEROLE.DRIVER': 'bestuurder',
		'ENUM.EVENTTYPE.COMMENT': 'Bericht',
		'ENUM.EVENTTYPE.CT': 'Teller',
		'ENUM.EVENTTYPE.CT_RS': 'Teller gereset',
		'ENUM.EVENTTYPE.CUSTOMER': 'Klant',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Medewerker koppelt de bijlage',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Medewerker betreedt het veld',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Medewerker betreedt de machine',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Werknemer verlaat veld',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Medewerker verlaat de machine',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Medewerker neemt pauze',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Werknemer beëindigt pauze',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Medewerker ontkoppelt de bijlage',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Werknemer gaat aan het werk',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Medewerker maakt het werk af',
		'ENUM.EVENTTYPE.GTO70': 'Graantank> 70%',
		'ENUM.EVENTTYPE.JOBINFO': 'Job info',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Job pause',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Met job doorgaan',
		'ENUM.EVENTTYPE.JOB_START': 'Job begin',
		'ENUM.EVENTTYPE.JOB_STOP': 'Job einde',
		'ENUM.EVENTTYPE.L_IMPL': 'Laad de bijlage',
		'ENUM.EVENTTYPE.REFUELING': 'Bijtanken',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'SyreN klant',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'SyreN-veld',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'SyreN drijfmest type',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Werktuig lossen',
		'ENUM.EVENTTYPE.WEATHER': 'Weer',
		'ENUM.EVENTTYPE.WEIGHING': 'Weging',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Weging (tarra)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'gemaakt',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'Op machine',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Klaar',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Gearchiveerd',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Word verwijdert',
		'ENUM.JOBGENERATIONSTATE.EDT': 'wordt bewerkt',
		'ENUM.JOBGENERATIONSTATE.GEN': 'herberekening',
		'ENUM.JOBGENERATIONSTATE.MER': 'Samenvoegen',
		'ENUM.JOBGENERATIONSTATE.QUE': 'In de wachtrij',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'herberekening',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Splitsen',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Bijwerken van',
		'ENUM.LOCATIONTYPE.FARM': 'Boerderij',
		'ENUM.LOCATIONTYPE.FUEL': 'Tankstation',
		'ENUM.LOCATIONTYPE.OTHERS': 'Andere',
		'ENUM.LOCATIONTYPE.STABLE': 'Stabiel',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Schaal',
		'ENUM.MACHINETYPE.COMBINE': 'Oogstmachine',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Graafmachine',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Hakselaar',
		'ENUM.MACHINETYPE.MISC': 'andere',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Zelfrijdend',
		'ENUM.MACHINETYPE.SYREN': 'SyreN',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Verreiker',
		'ENUM.MACHINETYPE.TRACTOR': 'Tractor',
		'ENUM.MACHINETYPE.TRUCK': 'Vrachtwagen',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Wiel lader',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Aantal assen',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Altijd',
		'ENUM.ONLY_ON_STATE.F': 'Feld',
		'ENUM.ONLY_ON_STATE.L': 'Locatie',
		'ENUM.ONLY_ON_STATE.R': 'Straat',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Type 1 (schrijft op USB-stick)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Type 2 (schrijft niet op USB-stick)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Aantal assen',
		'ENUM.TRANSPORTUNIT.BALE': 'Baal',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Beheerder',
		'ENUM.USERROLE.ENTERPRISE': 'Onderneming',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tech. Saleforce',
		'ENUM.USERROLE.TRAN': 'Vertaling',
		'ENUM.USERROLE.USER': 'Gebruiker',
		'ENUM.USERROLE.USER_EMPL': 'Gebruiker (Enterprise)',
		'ENUM.USERSTATE.ACTIVE': 'Actief',
		'ENUM.USERSTATE.DISABLED': 'geblokkeerd',
		'ENUM.USERSTATE.NOT_VERIFIED': 'niet geverifieerd',
		'ENUM.WORKSTATE.DRIVING': 'Het rijden',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Wachttijd rijden',
		'ENUM.WORKSTATE.MISC_FIELD': 'Wachttijd feld',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Graantank vol',
		'ENUM.WORKSTATE.MISC_ROAD': 'Wachten weg',
		'ENUM.WORKSTATE.PAUSE': 'Pauze',
		'ENUM.WORKSTATE.PREPARATION': 'Voorbereiding',
		'ENUM.WORKSTATE.ROAD': 'Straat',
		'ENUM.WORKSTATE.THRESHING': 'Dorsen',
		'ENUM.WORKSTATE.THRESHING_U': 'Lossen tijdens het dorsen',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Dorsen met een strohakselaar',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Lossen tijdens het dorsen met de strohakselaar',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Laad reizen',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Geladen wachten',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Geladen',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Uitgeladen',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Wachten uitgeladen',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Uitgeladen wachten',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Lossen tijdens het dorsen',
		'ENUM.WORKSTATE.TURNING': 'Draaien',
		'ENUM.WORKSTATE.UNDEFINED': 'Ongedefinieerd',
		'ENUM.WORKSTATE.WORKING': 'Werken',
		'ENUM.WORKSTATE.WORKING_MISC': 'Wachttijd werk',
		'ERROR.NO_GPS_DATA': 'Geen gps-gegevens voor de geselecteerde machine.',
		'ERROR_MESSAGE': 'Foutmelding',
		'EVENTS': 'Evenementen',
		'EVENTS.FIELD': 'Evenementen op het veld',
		'EVENTS.NO': 'Geen Evenementen',
		'EXA_ADAPTERS': 'Adapter',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Adaptar in Agrirouter activeren',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Adapter in Agrirouter verwijderen',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adapter in Agrirouter geactiveerd',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adapter van Agrirouter verwijdert',
		'EXCEPTION.1': 'Interne Server Fout',
		'EXCEPTION.100': 'Enum ongeldig',
		'EXCEPTION.1000': 'Gebruikersnaam mag niet leeg zijn!',
		'EXCEPTION.10000': 'Bestandsnaam mag niet leeg zijn!',
		'EXCEPTION.10001': 'Dataveld mag niet leeg zijn!',
		'EXCEPTION.10002': 'Gegevensformaat is niet geldig!',
		'EXCEPTION.10003': 'Ongeldig verzoek!',
		'EXCEPTION.10004': 'Geen ruwe data beschikbaar',
		'EXCEPTION.1001': 'Gebruikersnaam te kort',
		'EXCEPTION.1002': 'Gebruikersnaam is al bezet',
		'EXCEPTION.1003': 'Ongeldig e-mailadres',
		'EXCEPTION.1004': ' E-mailadres is al bezet',
		'EXCEPTION.1005': 'Wachtwoord te kort',
		'EXCEPTION.1007': 'Activeringscode is ongeldig',
		'EXCEPTION.1008': 'E-mailadres of gebruikersnaam niet bekend',
		'EXCEPTION.101': 'Ongeldige rol voor medewerkers',
		'EXCEPTION.1011': 'Gebruiker bestaat niet',
		'EXCEPTION.1012': 'De gebruiker is verwijderd',
		'EXCEPTION.1013': 'De gebruiker is inactief',
		'EXCEPTION.1014': 'De gebruiker is geblockeerd',
		'EXCEPTION.1015': 'Gebruiker is niet geactiveerd',
		'EXCEPTION.1016': 'De gebruiker is een klantaccount',
		'EXCEPTION.102': 'Onbekende valuta',
		'EXCEPTION.1020': 'De gebruiker bestaat al',
		'EXCEPTION.1021': 'Er bestaat al een gebruikersaccount met dit e-mailadres',
		'EXCEPTION.1022': 'Uw e-mailadres is niet gewijzigd',
		'EXCEPTION.1023': 'Het ingevoerde wachtwoord is onjuist',
		'EXCEPTION.1024': 'Gebruikersnaam is al bezet',
		'EXCEPTION.1025': 'Gebruiker en activeringscode komen niet overeen',
		'EXCEPTION.1026': 'Ongeldige gebruikersnaam / e-mailadres',
		'EXCEPTION.1027': 'De gebruiker is al geactiveerd',
		'EXCEPTION.1028': 'Niet toegestaan ​​voor accounts die door een bedrijf zijn gemaakt',
		'EXCEPTION.103': 'Transporteenheid onbekend',
		'EXCEPTION.104': 'Locatietype ongeldig',
		'EXCEPTION.105': 'Kosteneenheid ongeldig',
		'EXCEPTION.106': 'Eenheid ungeldig',
		'EXCEPTION.107': 'Ongeldig machinetype',
		'EXCEPTION.108': 'Ongeldige werknemersstatus',
		'EXCEPTION.11000': 'Ongeldig gegevenstype',
		'EXCEPTION.12000': 'Ongeldig gegevenstype',
		'EXCEPTION.12002': 'Serienummer mag niet leeg zijn!',
		'EXCEPTION.12003': 'Toestand ongeldig',
		'EXCEPTION.12004': 'Taakstatus ongeldig',
		'EXCEPTION.12006': 'Geen T2 config beschickbaar',
		'EXCEPTION.12007': 'MAC-adres mag niet leeg zijn!',
		'EXCEPTION.12008': 'MAC-Adres is ongeldig',
		'EXCEPTION.12009': 'Adapter bestaat al',
		'EXCEPTION.12010': 'Adapter-type is ongeldig',
		'EXCEPTION.15000': 'De starttijd mag niet leeg zijn of in de toekomst liggen!',
		'EXCEPTION.15001': 'De stoptijd mag niet leeg zijn of in de toekomst liggen!',
		'EXCEPTION.15002': 'De stoptijd moet voor de starttijd liggen!',
		'EXCEPTION.15003': 'SiloPackage kan niet worden gegenereerd - geen RawData beschikbaar',
		'EXCEPTION.15004': 'RawData te oud',
		'EXCEPTION.16000': 'Naam mag niet leeg zijn!',
		'EXCEPTION.16001': 'Toegewezen klant bestaat niet',
		'EXCEPTION.16002': 'Markeringslijst mag niet leeg zijn!',
		'EXCEPTION.16003': 'Lijst met markeringen moet minstens 3 markeringen bevatten',
		'EXCEPTION.16004': 'Gebied mag niet \"0\" zijn',
		'EXCEPTION.16005': 'Markertype onbekend',
		'EXCEPTION.16006': 'Dit veld is niet bewerkt in de geselecteerde reis',
		'EXCEPTION.16007': 'De rastergrootte mag niet meer zijn dan de helft van de breedte en hoogte van het veld',
		'EXCEPTION.16008': 'Geen gegevens beschikbaar om te interpoleren',
		'EXCEPTION.16009': 'Er kan geen kaart worden gemaakt. Alle gegevenspunten bevatten dezelfde waarde',
		'EXCEPTION.17000': 'Naam mag niet leeg zijn!',
		'EXCEPTION.17001': 'Contact-persoon mag niet leeg zijn!',
		'EXCEPTION.17002': 'Telefoonnummer mag niet leeg zijn!',
		'EXCEPTION.17003': 'E-mailadres mag niet leeg zijn!',
		'EXCEPTION.17004': 'E-mailadres is ongeldig',
		'EXCEPTION.17005': 'Adres mag niet leeg zijn!',
		'EXCEPTION.17006': 'Postcode mag niet leeg zijn!',
		'EXCEPTION.17007': 'Stad mag niet leeg zijn!',
		'EXCEPTION.17008': 'Kleur is ongeldig ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Type is ongeldig',
		'EXCEPTION.19001': 'Type is ongeldig',
		'EXCEPTION.19002': 'MAC-adres mag niet leeg zijn!',
		'EXCEPTION.19003': 'MAC-adres is ongeldig',
		'EXCEPTION.19004': 'Het vermogen mag niet minder zijn dan 0',
		'EXCEPTION.19007': 'Werknemer moet worden ingesteld',
		'EXCEPTION.19008': 'Het beacon is geen werktuig-beacon',
		'EXCEPTION.19009': 'Het beacon is geen beacon voor de bestuurder',
		'EXCEPTION.2': 'Dubbele ingang',
		'EXCEPTION.200': 'Error parsing Json Object Type',
		'EXCEPTION.2000': 'Er kon geen authenticatiecode worden gegenereerd',
		'EXCEPTION.20000': 'Te weinig RawData',
		'EXCEPTION.20001': 'Fout bij maken van archiefbestand',
		'EXCEPTION.20002': 'Fout bij het laden van de archiefgegevens',
		'EXCEPTION.2001': 'Authenticatiecode bestaat niet',
		'EXCEPTION.2002': 'Authenticatiecode is ongeldig',
		'EXCEPTION.201': 'Error writing Object Type to Json',
		'EXCEPTION.21000': 'Bedrijfsnaam mag niet leeg zijn!',
		'EXCEPTION.21001': 'Bedrijfsnaam bestaat al',
		'EXCEPTION.21002': 'Bedrijfsnaam is te kort',
		'EXCEPTION.21003': 'E-mailadres van het bedrijf is ongeldig',
		'EXCEPTION.21004': 'Toegangstoken bestaat al',
		'EXCEPTION.21005': 'Bedrijf is verwijdert',
		'EXCEPTION.21006': 'Bedrijf is gedeactiveerd',
		'EXCEPTION.21007': 'Bedrijf is geblockeerd',
		'EXCEPTION.21008': 'Bedrijfs-type is ongeldig',
		'EXCEPTION.22000': 'Er zijn geen trips om toe te voegen',
		'EXCEPTION.22001': 'Geen trips zijn verandert',
		'EXCEPTION.23000': 'Bedrijf niet aan boord',
		'EXCEPTION.23001': 'Bedrijf al aan boord',
		'EXCEPTION.23002': 'Adapter is niet aan boord',
		'EXCEPTION.23003': 'Adapter is al aan boord',
		'EXCEPTION.23004': 'Kan adapter niet inbouwen',
		'EXCEPTION.23005': 'Adapter kon niet opnieuw worden ingebouwd',
		'EXCEPTION.23006': 'Kan adapter niet offboard',
		'EXCEPTION.23007': 'Het publiceren van vCU-mogelijkheden is mislukt',
		'EXCEPTION.23008': 'Publiceren van vCU-gegevens is mislukt',
		'EXCEPTION.23009': 'Publiceren vCU-apparaatbeschrijving is mislukt',
		'EXCEPTION.23010': 'Het publiceren van bedrijfsmogelijkheden is mislukt',
		'EXCEPTION.23011': 'Er was een probleem met het agrirouter-certificaat. Heeft u het agrirouter-certificaat vernieuwd?',
		'EXCEPTION.24000': 'Bedrijfsnaam mag niet leeg zijn!',
		'EXCEPTION.24001': 'Bedrijfsnaam bestaat al',
		'EXCEPTION.24002': 'Bedrijfsnaam is the kort',
		'EXCEPTION.24003': 'Bedrijfs e-mail is ongeldig',
		'EXCEPTION.24004': 'Bedrijfstoegangscode bestaat al',
		'EXCEPTION.24005': 'Bedrijf is verwijdert',
		'EXCEPTION.24006': 'Bedrijf is gedeactiveerd',
		'EXCEPTION.24007': 'Bedrijf is geblockeerd',
		'EXCEPTION.25000': 'Functie niet beschikbaar voor geselecteerde partner',
		'EXCEPTION.25001': 'Het synchroniseren van velden is mislukt',
		'EXCEPTION.25002': 'Het synchroniseren van machines is mislukt',
		'EXCEPTION.25003': 'Het synchroniseren van werktuigen is mislukt',
		'EXCEPTION.25004': 'Het ophalen van de machine is mislukt',
		'EXCEPTION.25005': 'Maken van machine is mislukt',
		'EXCEPTION.25006': 'Het updaten van de machine is mislukt',
		'EXCEPTION.25007': 'Het verwijderen van de machine is mislukt',
		'EXCEPTION.25008': 'Het verkrijgen van het werktuig is mislukt',
		'EXCEPTION.25009': 'Maken van werktuig is mislukt',
		'EXCEPTION.25010': 'Het updaten van de implementatie is mislukt',
		'EXCEPTION.25011': 'Verwijderen van werktuig is mislukt',
		'EXCEPTION.26000': 'Er is een fout opgetreden bij het maken van het pdf-document',
		'EXCEPTION.26001': 'De geselecteerde rit is niet van een SyreN-machine',
		'EXCEPTION.27000': 'Machine ondersteunt geen bestandsoverdracht',
		'EXCEPTION.27001': 'Fout bij het maken van het bestand',
		'EXCEPTION.27002': 'Fout bij laden van bestand',
		'EXCEPTION.27003': 'Er is geen adapter toegewezen aan de geselecteerde machine',
		'EXCEPTION.27004': 'Het veld \"naam\" is leeg',
		'EXCEPTION.27005': 'Het veld \"Geplande datum\" moet zijn ingesteld',
		'EXCEPTION.27006': '\"Geplande datum\" onjuist! (alleen in de toekomst mogelijk)',
		'EXCEPTION.27007': 'Status moet worden ingesteld',
		'EXCEPTION.27008': 'Geen bestand geselecteerd',
		'EXCEPTION.27009': 'De bestandsnaam moet worden ingesteld',
		'EXCEPTION.27010': 'Datum moet worden ingesteld',
		'EXCEPTION.27011': 'Datum ongeldig(alleen in de toekomst mogelijk)',
		'EXCEPTION.27012': 'Grootte mag niet kleiner zijn dan 1',
		'EXCEPTION.27013': 'TaskData-bewerking niet mogelijk met de huidige status',
		'EXCEPTION.27014': 'Bestandsnaam is al in gebruik',
		'EXCEPTION.27015': 'Er zijn momenteel geen openstaande taken',
		'EXCEPTION.27016': 'Er kan slechts één niet-gedownload bestand zijn',
		'EXCEPTION.28001': 'Bestandsformaat wordt niet ondersteund',
		'EXCEPTION.29000': 'Update niet toegestaan ​​(al verwerkt)',
		'EXCEPTION.29001': 'Geen machine of werktuig gegeven',
		'EXCEPTION.29002': 'Alleen machine OF werktuig toegestaan',
		'EXCEPTION.29003': 'De basiswaarde moet groter zijn dan nul',
		'EXCEPTION.29004': 'De waarschuwingswaarde moet groter zijn dan nul',
		'EXCEPTION.29005': 'De verschuldigde waarde moet groter zijn dan nul',
		'EXCEPTION.29006': 'Het verschuldigde interval moet groter zijn dan het waarschuwingsinterval',
		'EXCEPTION.3000': 'Inloggegevens ongeldig',
		'EXCEPTION.3001': 'Account is geblokkeerd',
		'EXCEPTION.3002': 'Account is niet geactiveerd',
		'EXCEPTION.3003': 'Sessie verlopen - Log opnieuw in',
		'EXCEPTION.3004': 'Een andere gebruiker heeft zich aangemeld met hetzelfde account',
		'EXCEPTION.31000': 'App word niet ondersteund',
		'EXCEPTION.4000': 'Fabrikant mag niet leeg zijn',
		'EXCEPTION.4001': 'Model mag niet leeg zijn',
		'EXCEPTION.4002': 'Het bouwjaar kan niet voor 1950 of in de toekomst liggen',
		'EXCEPTION.4003': 'Het kostentarief mag niet 0 of negatief zijn',
		'EXCEPTION.4004': 'De bedrijfsuren mogen niet <0 zijn',
		'EXCEPTION.4005': 'De kilometerstand mag niet <0 zijn',
		'EXCEPTION.4007': 'De werkbreedte mag niet negatief zijn',
		'EXCEPTION.4008': 'Kleur ongeldig  ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig bevat geen geldige gegevens',
		'EXCEPTION.401': 'Ongeautoriseerd',
		'EXCEPTION.4010': 'Te veel configuratie-waarden',
		'EXCEPTION.4011': 'Dynamische configuratie bevat geen geldige gegevens',
		'EXCEPTION.4012': 'De machine is geen tractor',
		'EXCEPTION.4013': 'Het maximale aantal TC-licenties is al bezet',
		'EXCEPTION.4014': 'Datum mag niet in de toekomst liggen',
		'EXCEPTION.4015': 'Snelheidssignaal overschrijven onjuist',
		'EXCEPTION.403': 'Verboden',
		'EXCEPTION.450': 'Commandofout',
		'EXCEPTION.451': 'Vereiste licentie niet beschikbaar!',
		'EXCEPTION.452': 'Filterparameter ongeldig',
		'EXCEPTION.5000': 'Fabrikant mag niet leeg zijn',
		'EXCEPTION.5001': 'Model mag niet leeg zijn',
		'EXCEPTION.5002': 'Het bouwjaar kan niet voor 1950 of in de toekomst liggen',
		'EXCEPTION.5003': 'Type 1 mag niet leeg zijn',
		'EXCEPTION.5004': 'Type 2 mag niet leeg zijn',
		'EXCEPTION.5005': 'Der Kostensatz darf nicht 0 oder negativ sein',
		'EXCEPTION.5006': 'De werkbreedte mag niet negatief zijn',
		'EXCEPTION.5007': 'De transportcapaciteit mag niet negatief zijn',
		'EXCEPTION.5008': 'Transporteenheid ongeldig',
		'EXCEPTION.5009': 'Type 3 is ongeldig',
		'EXCEPTION.5010': 'Typecombinatie ongeldig',
		'EXCEPTION.5011': 'Typecombinatie ongeldig',
		'EXCEPTION.6000': 'Type ongeldig',
		'EXCEPTION.6001': 'Straal mag niet leeg of negatief zijn',
		'EXCEPTION.6002': 'Naam mag niet leeg zijn',
		'EXCEPTION.6003': 'Markeringslijst mag niet leeg zijn',
		'EXCEPTION.6004': 'Markerlijst moet minstens 3 markers bevattenMarkerlijst moet minstens 3 markers bevatten',
		'EXCEPTION.6005': 'Markeringstype ongeldig',
		'EXCEPTION.6006': 'Weegtype ongeldig',
		'EXCEPTION.700': 'VarNaam ongeldig',
		'EXCEPTION.7001': 'Account bestaat niet',
		'EXCEPTION.7002': 'Account is geblockeerd',
		'EXCEPTION.701': 'Formule ongeldig',
		'EXCEPTION.702': 'CANIdNaam is ongeldig',
		'EXCEPTION.703': 'Conditie is ongeldig',
		'EXCEPTION.704': 'VarNaam is ongeldig',
		'EXCEPTION.705': 'Ongeldige statusparameters',
		'EXCEPTION.706': 'Workstate ongeldig voor ImplementType',
		'EXCEPTION.707': 'Het bestand kan niet gemaakt worden',
		'EXCEPTION.800': 'ConfigValue naam is ongeldig',
		'EXCEPTION.8000': 'Werkgever mag niet leeg zijn',
		'EXCEPTION.8001': 'Werknemer mag niet leeg zijn',
		'EXCEPTION.8002': 'Werknemer niet gevonden voor bedrijf',
		'EXCEPTION.8003': 'De kosten mogen niet negatief zijn',
    'EXCEPTION.8004': 'Maximaal aantal gebruikerslicenties in gebruik',
		'EXCEPTION.8005': 'Niet uw werkgever',
		'EXCEPTION.8006': 'Medewerker bestaat al',
		'EXCEPTION.8007': 'Acces token mag niet leeg zijn',
		'EXCEPTION.8008': 'Acces token is ongeldig',
		'EXCEPTION.8009': 'Er moet ten minste één beheerder in een bedrijf zijn',
		'EXCEPTION.8010': 'De gebruiker kan alleen worden verbonden met het bedrijf dat het heeft gemaakt',
		'EXCEPTION.900': 'Bestaat niet',
		'EXCEPTION.9000': 'Starttijd mag niet leeg zijn of in de toekomst liggen',
		'EXCEPTION.9001': 'Stoptijd mag niet leeg zijn of in de toekomst liggen',
		'EXCEPTION.9002': 'De stoptijd mag niet gelijk als de starttijd zijn of voor de startijd liggen',
		'EXCEPTION.9003': 'Bestuurder is geen medewerker van het bedrijf',
		'EXCEPTION.9004': 'Werktuig behoort niet tot taakeigenaar',
		'EXCEPTION.9005': 'Type 1 is ongeldig',
		'EXCEPTION.9006': 'Type 2 is ongeldig',
		'EXCEPTION.9007': 'Type 3 is ongeldig',
		'EXCEPTION.9008': 'Taak kan niet worden gegenereerd - geen RawData beschikbaar',
		'EXCEPTION.9009': 'De eigenaar van de machine komt niet overeen met de eigenaar van het werktuig',
		'EXCEPTION.901': 'Bestaat al',
		'EXCEPTION.9010': 'Taak bestaat al',
		'EXCEPTION.9012': 'Taak is nog niet bereid',
		'EXCEPTION.9013': 'Taak word verwijdert',
		'EXCEPTION.9014': 'Taak is gearchiveerd en bevat geen taaklocaties',
		'EXCEPTION.9015': 'RawDate is te oud',
		'EXCEPTION.9016': 'Minstens één baan maakt deel uit van een taak',
		'EXCEPTION.9017': 'Taken komen niet overeen (machine, bestuurder, werktuig moeten overeenkomen)',
		'EXCEPTION.9018': 'Taken liggen te ver uit elkaar',
		'EXCEPTION.9019': 'Minstens één baan maakt deel uit van een taak',
		'EXCEPTION.902': 'Eigenaar bestaat niet',
		'EXCEPTION.9020': 'Geen tussentijden beschikbaar',
		'EXCEPTION.9021': 'De taak tussentijd ligt niet tussen de start- en stoptijden van de taak',
		'EXCEPTION.9022': 'Geen taak-ID\'s voor samenvoegen',
		'EXCEPTION.9023': 'Minstens één taak nodig',
		'EXCEPTION.9024': 'Puntdichtheid moet> 0 en <= 1 zijn',
		'EXCEPTION.903': 'Object met ID bestaat niet',
		'EXCEPTION.904': 'Breedtegraad moet tussen -90 en +90 zijn',
		'EXCEPTION.905': 'De lengtegraad moet tussen -180 en +180 liggen',
		'EXCEPTION.906': 'Eigenaren zijn het daar niet mee eens',
		'EXCEPTION.907': 'Parameter niet ingesteld',
		'EXCEPTION.99': 'Parameter ongeldig',
		'EXPORT': 'exporteren',
		'EXPORT.FILTERED_JOBS': 'Exporteer alle gefilterde taken',
		'EXPORT.JOB_DETAILS': 'Exporteer taakdetails',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Alle gegevens voor klant in geselecteerde periode exporteren',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Exporteer alle bewerkingen op velden in de geselecteerde periode',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Alle operaties op locaties in de geselecteerde periode exporteren',
		'EXPORT.POINTS': 'Datapunten',
		'EXPORT.POLYGONS': 'Polygonen',
		'EXPORT.RAW_DATA_AS_SILO': 'Exporteer ruwe data van de job als SILO-bestand',
		'EXPORT.SELECTED': 'Export geselecteerde',
		'EXPORT.SELECT_DATA': 'De volgende informatie moet worden opgenomen in het pdf-rapport:',
		'EXPORT.SELECT_PERIOD': 'Selecteer de periode om te exporteren:',
		"FERTILIZER": "Kunstmest",
		'FIELD': 'Veld',
		'FIELD.ADD': 'Veld toevoegen',
		'FIELD.ADD.SUCCESS': 'Veld succesvol toegevoegd',
		'FIELD.DEACTIVATE.QUESTION': 'Wil je het veld echt deactiveren?',
		'FIELD.DEACTIVATE.SUCCESS': 'Veld succesvol gedeactiveerd',
		'FIELD.DELETE.QUESTION': 'Wilt u deze veld echt verwijderen?',
		'FIELD.DELETE.SUCCESS': 'Veld succesvol verwijdert',
		'FIELD.DETAILS': 'Veld details',
		'FIELD.DRAW.START': 'Teken nu akkergrenzen op de kaart!',
		'FIELD.EDIT.SUCCESS': 'Veld succesvol bewerkt',
		'FIELD.INTERPOLATE': 'Maak een kaart',
		'FIELD.INTERPOLATED_VALUES': 'Geïnterpoleerde waarden',
		'FIELD.INTERPOLATION': 'Kaart tool',
		'FIELD.INTERPOLATION_SETTINGS': 'Interpolatie-instellingen',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Prima',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Zeer prima',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'ruw',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'standaard',
		'FIELD.NUMBER': 'Veld nummer',
		'FIELD.PROCESSED': 'Verwerkt veld',
		'FIELDS': 'Velden',
		'FIELDS.ALL': 'Alle velden',
		'FIELDS.DEACTIVATE.FAILURE': 'Sommige velden konden niet worden gedeactiveerd.',
		'FIELDS.DEACTIVATE.QUESTION': 'Wil je de velden echt deactiveren?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Velden succesvol gedeactiveerd',
		'FIELDS.DELETE.FAILURE': 'Sommige velden kunnen verwijdert worden',
		'FIELDS.DELETE.QUESTION': 'Wilt u werkelijk de geselecteerde velden verwijderen?',
		'FIELDS.DELETE.SUCCESS': 'Velden werden succesvol verwijdert',
		'FIELDS.EDIT': 'Velden bewerken',
		'FIELDS.IMPORT': 'Velden importeren',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Wilt u een klant aan de geselecteerde velden toewijzen?',
		'FIELDS.IMPORT.SHAPE': 'Selecteer een SHAPE-bestand om te importeren.',
		'FIELDS.IMPORT.SUCCESS': 'Succesvol geïmporteerde velden',
		'FIELDS.MANAGEMENT': 'Veldbeheer',
		'FIELDS.NO': 'Geen velden',
		'FIELDS.NOT_SELECTED': 'Geen velden geselecteerd',
		'FIELDS.REACTIVATE.FAILURE': 'Sommige velden konden niet worden gereactiveerd.',
		'FIELDS.REACTIVATE.QUESTION': 'Wil je de geselecteerde velden echt opnieuw activeren?',
		'FIELDS.REACTIVATE.SUCCESS': 'Velden succesvol gereactiveerd',
		'FIELDS.SELECT': 'Selecteer velden',
		'FIELDS.SELECTED': 'Velden geselcteerd',
		'FILE': 'Bestand',
		'FILE.GENERATING': 'Bestand wordt gegenereerd en binnenkort toegevoegd aan bestandsbeheer',
		'FILE.GENERATING.READY': 'Een nieuw bestand is klaar om te downloaden',
		'FILE.MANAGER': 'Bestandsbeheer',
		'FILE.NO_FILES': 'Geen bestaande bestanden',
		'FILE.UPLOAD': 'Bestand uploaden',
		'FILE_TRANSFER': 'ISOTaskData-beheer',
		'FILE_TRANSFER.ADD': 'Voeg ISOTaskData toe',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData succesvol toegevoegd',
		'FILE_TRANSFER.CREATE': 'Voeg ISOTaskData toe',
		'FILE_TRANSFER.DELETE.QUESTION': 'Wilt u de ISOTaskData echt verwijderen?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData succesvol verwijderd',
		'FILE_TRANSFER.FINISHED_TASKS': 'Verwerkte taken',
		'FILE_TRANSFER.NO': 'Geen ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Taken in de wachtrij',
		'FILTER': 'Filter',
		'FIRMWARE_VERSION': 'Firmware versie',
		'FIRSTNAME': 'Voornaam',
		'FORMS.FILE_TOO_LARGE': 'Bestand is te groot',
		'FORMS.NO_PASSWORD_MATCH': 'Wachtwoorden komen niet overeen',
		'FORMS.REQUIRED': 'word benodigd',
    'FORMS.INVALID_EMAIL': 'Ongeldig e-mailadres',
		'FORMULA': 'Formule',
		'FUEL': 'Brandstof',
		'FUEL.CONSUMPTION': 'Brandstofverbruik',
		'FUEL.CONSUMPTION.AREA': 'Brandstofverbruik per oppervlakte',
		'FUEL.CONSUMPTION.AVERAGE': 'Gemiddelde brandstofverbruik',
		'FUEL.CONSUMPTION.OVERALL': 'Totaal brandstofverbruik',
		'FUEL.CONSUMPTION.TOTAL': 'Totale brandstofverbruik',
		'FUEL.COST': 'Brandstofprijs',
		'FUEL.LEVEL': 'Brandstofniveau',
		'FUEL.PRICE_PER_LITER': 'Brandstofprijs per liter',
		'FUEL.WARNING': 'Brandstofniveau laag',
		'GENERAL_INSPECTION': 'Algemene Inspectie',
		'GEOMETRIES.UPDATE': 'Velden en locaties bijwerken',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Alle onderliggende gegevens moeten worden bijgewerkt om ze correct toe te wijzen na het toevoegen van een nieuwe geometrie. Wilt u de gegevens nu bijwerken?',
		'GEOMETRY.CLICK_TO_SAVE': 'Om op te slaan, klik op de kaart.',
		'GPS': ' GPS ',
		'GPS.GPS': 'Interne GPS',
		'GPS.LP': 'Laatst bekende positie',
		'GPS.RTK': ' RTK ',
		'GPS.RTK_H': 'RTK (hoge precisie)',
		'GPS.STATUS': 'GPS-status',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Afstand tussen GPS en trekhaak',
		'HARDWARE': ' Hardware ',
		'HARDWARE.SETUP.PRINT_STICKER': 'Hardwaresticker afdrukken',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Verpakkingssticker afdrukken',
		'HARDWARE.SETUP.RESET_DEVICE': 'Apparaat resetten',
		'HARDWARE.SETUP.SET_SERIAL': 'Serieel instellen',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Model volgens de invoer',
		'HINT_MARKERS.SHOW': 'Toon aanwijzingsmarkers',
		'HITCH_TO_APPLICATION_DISTANCE': 'Afstand tussen hefinrichting en toepassing',
		'HITCH:INVALID': 'Voer een geldige numerieke waarde in (maximaal één decimaal, negatieve of positieve waarden zijn toegestaan).',
		'HOME': 'Welkom',
		'HOME.CONTACTREPLY1': 'Bel ons dan gerust op',
		'HOME.CONTACTREPLY2': 'of schrijf ons een e-mail aan',
		'HOME.INTRODUCTORY_VIDEOS': 'Inleidende video\'s',
		'HOME.NEWSINFO1': 'Al het nieuws en spannende informatie over wagenparkbeheer en het volgen van machines is te vinden op onze',
		'HOME.NEWSINFO2': 'of op onze',
		'HOME.PROFILEEXPLANATION': 'Onder \"Mijn profiel\" kunt u uw persoonlijke gegevens, uw e-mailadres en uw wachtwoord wijzigen.',
		'HOME.QUESTIONSYSTEM': 'Heeft u vragen over ons systeem?',
		'HOME.TITLE': 'Welkom',
		'HOME.WELCOMEAREA': 'hartelijk welkom bij jouw bereik!',
		'IDLE': 'Neutrale',
		'IGNORE': 'Negeer',	
		'IMPLEMENT': 'Werktuig',
		'IMPLEMENT.ADD': 'Voeg werktuig toe',
		'IMPLEMENT.ADD.SUCCESS': 'Werktuig succesvol toegevoegd',
		'IMPLEMENT.CLASS': 'Werktuig klas',
		'IMPLEMENT.DELETE.QUESTION': 'Wilt u het werktuig echt verwijderen?',
		'IMPLEMENT.DELETE.SUCCESS': 'Werktuig succesvol verwijdert',
		'IMPLEMENT.DETAILS': 'Werktuig details',
		'IMPLEMENT.EDIT': 'Werktuig bewerken',
		'IMPLEMENT.EDIT.SUCCESS': 'Werktuig succesvol bewerkt',
		'IMPLEMENT.FIXED': 'Vast werktuig',
		'IMPLEMENT.NO': 'Geen werktuig',
		'IMPLEMENT.PROCESS.0': 'Zonder uitvoering',
		'IMPLEMENT.PROCESS.1': 'Pers ronde balen',
		'IMPLEMENT.PROCESS.10': 'Rollen',
		'IMPLEMENT.PROCESS.11': 'Zaaien',
		'IMPLEMENT.PROCESS.12': 'Planten',
		'IMPLEMENT.PROCESS.13': 'Bemesting',
		'IMPLEMENT.PROCESS.14': 'Sproeien',
		'IMPLEMENT.PROCESS.15': 'Irrigeren',
		'IMPLEMENT.PROCESS.16': 'Gras maaien',
		'IMPLEMENT.PROCESS.17': 'Beurt',
		'IMPLEMENT.PROCESS.18': 'Transporteren',
		'IMPLEMENT.PROCESS.19': 'Vegen',
		'IMPLEMENT.PROCESS.2': 'Persen van vierkante balen',
		'IMPLEMENT.PROCESS.20': 'Sneeuwploegen',
		'IMPLEMENT.PROCESS.21': 'Zout verspreiden',
		'IMPLEMENT.PROCESS.22': 'Schoffelen',
		'IMPLEMENT.PROCESS.23': 'Bemesting',
		'IMPLEMENT.PROCESS.24': 'Drijfmest pompen',
		'IMPLEMENT.PROCESS.25': 'Drijfmest mengen',
		'IMPLEMENT.PROCESS.26': 'Aardappelen planten',
		'IMPLEMENT.PROCESS.27': 'Aardappelen oogsten',
		'IMPLEMENT.PROCESS.28': 'Scheiden',
		'IMPLEMENT.PROCESS.29': 'Aanaarden',
		'IMPLEMENT.PROCESS.3': 'Balen verpakken',
		'IMPLEMENT.PROCESS.30': 'Loofklappen',
		'IMPLEMENT.PROCESS.31': 'Zwaden',
		'IMPLEMENT.PROCESS.32': 'schrijnend',
		'IMPLEMENT.PROCESS.33': 'schrijnend',
		'IMPLEMENT.PROCESS.34': 'Hakking',
		'IMPLEMENT.PROCESS.35': 'Vegen',
		'IMPLEMENT.PROCESS.36': 'Sneeuw frezen',
		'IMPLEMENT.PROCESS.37': 'Verplaats de mestcontainer',
		'IMPLEMENT.PROCESS.38': 'Bedvormen',
		'IMPLEMENT.PROCESS.39': 'Eten geven',
		'IMPLEMENT.PROCESS.4': 'balen wikkelen',
		'IMPLEMENT.PROCESS.40': 'Verplaats hout',
		'IMPLEMENT.PROCESS.41': 'Hout zagen',
		'IMPLEMENT.PROCESS.42': 'Gespleten hout',
		'IMPLEMENT.PROCESS.43': 'Frezen van boomstronken',
		'IMPLEMENT.PROCESS.44': 'Stortgoed laden',
		'IMPLEMENT.PROCESS.45': 'Pallets laden',
		'IMPLEMENT.PROCESS.46': 'Balen laden',
		'IMPLEMENT.PROCESS.47': 'CCM-molens converteren',
		'IMPLEMENT.PROCESS.48': 'Duwen',
		'IMPLEMENT.PROCESS.49': 'Gewicht voor / achter',
		'IMPLEMENT.PROCESS.5': 'Ploegen',
		'IMPLEMENT.PROCESS.50': 'Dorsen',
		'IMPLEMENT.PROCESS.51': 'Hakken',
		'IMPLEMENT.PROCESS.52': 'Persen van balen onder hoge druk',
		'IMPLEMENT.PROCESS.53': 'Onverdoofd',
		'IMPLEMENT.PROCESS.54': 'Schaven',
		'IMPLEMENT.PROCESS.55': 'Grondbewerking',
		'IMPLEMENT.PROCESS.56': 'Uiterlijke verzorging',
		'IMPLEMENT.PROCESS.57': 'montage werk',
		'IMPLEMENT.PROCESS.58': 'Entrain',
		'IMPLEMENT.PROCESS.59': 'Laden en lossen',
		'IMPLEMENT.PROCESS.6': 'Cultiveren',
		'IMPLEMENT.PROCESS.60': 'Wassen',
		'IMPLEMENT.PROCESS.61': 'Verdichten',
		'IMPLEMENT.PROCESS.7': 'Schrijnend',
		'IMPLEMENT.PROCESS.8': 'Diep losmaken',
		'IMPLEMENT.PROCESS.9': 'Diep losmaken',
		'IMPLEMENT.PROCESS.deadhead': 'Zonder uitvoering',
		'IMPLEMENT.REMOVE': 'Werktuig verwijderen',
		'IMPLEMENT.RESOURCE.0': 'ongedefinieerd',
		'IMPLEMENT.RESOURCE.1': 'Voedergewassen',
		'IMPLEMENT.RESOURCE.10': 'Mest',
		'IMPLEMENT.RESOURCE.11': 'Drijfmest',
		'IMPLEMENT.RESOURCE.12': 'mengmest',
		'IMPLEMENT.RESOURCE.13': 'Digestaat',
		'IMPLEMENT.RESOURCE.14': 'Houtsnippers',
		'IMPLEMENT.RESOURCE.15': 'Maïs',
		'IMPLEMENT.RESOURCE.16': 'Zonnebloem',
		'IMPLEMENT.RESOURCE.17': 'kafferkoren',
		'IMPLEMENT.RESOURCE.18': 'Rogge',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Graskuilvoer',
		'IMPLEMENT.RESOURCE.20': 'Tarwe',
		'IMPLEMENT.RESOURCE.21': 'Veldboon',
		'IMPLEMENT.RESOURCE.22': 'Erwt',
		'IMPLEMENT.RESOURCE.23': 'Veld gras',
		'IMPLEMENT.RESOURCE.24': 'Klaver gras',
		'IMPLEMENT.RESOURCE.25': 'Gerst',
		'IMPLEMENT.RESOURCE.26': 'Haver',
		'IMPLEMENT.RESOURCE.27': 'Spelt',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Lijnzaad',
		'IMPLEMENT.RESOURCE.3': 'Kuilvoer van hele planten',
		'IMPLEMENT.RESOURCE.30': 'Koolzaad',
		'IMPLEMENT.RESOURCE.31': 'Soja bonen',
		'IMPLEMENT.RESOURCE.32': 'Gewas vangen',
		'IMPLEMENT.RESOURCE.33': 'Suikerbiet',
		'IMPLEMENT.RESOURCE.34': 'Aardappelen',
		'IMPLEMENT.RESOURCE.35': 'Miscanthus',
		'IMPLEMENT.RESOURCE.36': 'Topinamboer',
		'IMPLEMENT.RESOURCE.37': 'Groenten',
		'IMPLEMENT.RESOURCE.38': 'Aardbeien',
		'IMPLEMENT.RESOURCE.39': 'Vloeibare meststof',
		'IMPLEMENT.RESOURCE.4': 'Hooi',
		'IMPLEMENT.RESOURCE.40': 'Limoen',
		'IMPLEMENT.RESOURCE.41': 'Diammonphosphat',
		'IMPLEMENT.RESOURCE.42': 'Haarmeelkorrels, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Ureum',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Grond',
		'IMPLEMENT.RESOURCE.47': 'Plant beschermer',
		'IMPLEMENT.RESOURCE.48': 'gemengd',
		'IMPLEMENT.RESOURCE.49': 'Water',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Voedermix',
		'IMPLEMENT.RESOURCE.6': 'Maïs',
		'IMPLEMENT.RESOURCE.7': 'stro',
		'IMPLEMENT.RESOURCE.8': 'Kuilvoer van maïs',
		'IMPLEMENT.RESOURCE.9': 'Graan',
		'IMPLEMENT.TYPE': 'Type werktuig',
		'IMPLEMENT.TYPE.1': 'Balenpersen / wikkelaars',
		'IMPLEMENT.TYPE.10': 'Transport aanhangwagens',
		'IMPLEMENT.TYPE.10_1': 'Driezijdige kipper',
		'IMPLEMENT.TYPE.10_10': 'Dieplader aanhangwagen',
		'IMPLEMENT.TYPE.10_11': 'Aanhangwagen met haakarmsysteem',
		'IMPLEMENT.TYPE.10_12': 'Vee aanhangwagen',
		'IMPLEMENT.TYPE.10_13': 'Oplegger dolly',
		'IMPLEMENT.TYPE.10_14': 'Tankwagen / silowagens',
		'IMPLEMENT.TYPE.10_2': 'Opbouw kipper',
		'IMPLEMENT.TYPE.10_3': 'Jager bak',
		'IMPLEMENT.TYPE.10_4': 'Platform aanhanger',
		'IMPLEMENT.TYPE.10_5': 'Opraapwagen',
		'IMPLEMENT.TYPE.10_6': 'Silage-aanhanger',
		'IMPLEMENT.TYPE.10_7': 'Aanhangwagen voor balenvervoer',
		'IMPLEMENT.TYPE.10_8': 'Afschuifwagen',
		'IMPLEMENT.TYPE.10_9': 'Tankwagen voor vloeibare mest',
		'IMPLEMENT.TYPE.11': 'Vee-uitrusting',
		'IMPLEMENT.TYPE.11_1': 'Getrokken voermengwagen',
		'IMPLEMENT.TYPE.11_2': 'Verdeelwagen voor veevoeder',
		'IMPLEMENT.TYPE.11_3': 'Ophaal- / distributiewagen',
		'IMPLEMENT.TYPE.12': 'Bosbouw',
		'IMPLEMENT.TYPE.12_1': 'Bos aanhangwagen',
		'IMPLEMENT.TYPE.12_2': 'Brandhout zag',
		'IMPLEMENT.TYPE.12_3': 'brandhout processor',
		'IMPLEMENT.TYPE.12_4': 'Hout doorklieven',
		'IMPLEMENT.TYPE.12_5': 'Stobbenfrees',
		'IMPLEMENT.TYPE.12_6': 'Lier voor bosbouw',
		'IMPLEMENT.TYPE.12_7': 'Bosbouw mulcher',
		'IMPLEMENT.TYPE.12_8': 'Houtversnipperaar',
		'IMPLEMENT.TYPE.12_8_1': 'Gemonteerde versnipperaar',
		'IMPLEMENT.TYPE.12_8_2': 'Getrokken schijvenhakselaar',
		'IMPLEMENT.TYPE.12_8_3': 'Gemonteerde trommelversnipperaar',
		'IMPLEMENT.TYPE.12_8_4': 'Getrokken trommelversnipperaar',
		'IMPLEMENT.TYPE.12_8_5': 'Getrokken trommelversnipperaar (zelfrijdend)',
		'IMPLEMENT.TYPE.12_9': 'Hydraulische nedge trimmer',
		'IMPLEMENT.TYPE.13': 'Gemeentelijke uitrusting',
		'IMPLEMENT.TYPE.13_1': 'Veegmachines',
		'IMPLEMENT.TYPE.13_10': 'Padonderhoudsapparaat',
		'IMPLEMENT.TYPE.13_11': 'Banket freesmachine',
		'IMPLEMENT.TYPE.13_12': 'Zoutvaatje - gemonteerd',
		'IMPLEMENT.TYPE.13_13': 'nul',
		'IMPLEMENT.TYPE.13_14': 'Wasapparaat',
		'IMPLEMENT.TYPE.13_15': 'Irrigatie-apparaat',
		'IMPLEMENT.TYPE.13_16': 'Werkplatform',
		'IMPLEMENT.TYPE.13_17': 'Oppervlakte mulcher',
		'IMPLEMENT.TYPE.13_18': 'Outrigger voorkant',
		'IMPLEMENT.TYPE.13_18_1': 'Snijkop',
		'IMPLEMENT.TYPE.13_18_2': 'Mulchkop',
		'IMPLEMENT.TYPE.13_18_3': 'Heggenschaar',
		'IMPLEMENT.TYPE.13_18_4': 'Clearing mand',
		'IMPLEMENT.TYPE.13_18_5': 'Hark',
		'IMPLEMENT.TYPE.13_19': 'Stempelcentrum/structuur',
		'IMPLEMENT.TYPE.13_19_1': 'Snijkop',
		'IMPLEMENT.TYPE.13_19_2': 'Mulchkop',
		'IMPLEMENT.TYPE.13_19_3': 'Heggenschaar',
		'IMPLEMENT.TYPE.13_19_4': 'Clearing mand',
		'IMPLEMENT.TYPE.13_19_5': 'Hark',
		'IMPLEMENT.TYPE.13_1_1': 'Voorste veegmachine',
		'IMPLEMENT.TYPE.13_1_2': 'Veegmachine achter',
		'IMPLEMENT.TYPE.13_1_3': 'Structuur',
		'IMPLEMENT.TYPE.13_2': 'Sneeuwploeg',
		'IMPLEMENT.TYPE.13_20': 'Outrigger achteraan',
		'IMPLEMENT.TYPE.13_20_1': 'Snijkop',
		'IMPLEMENT.TYPE.13_20_2': 'Mulchkop',
		'IMPLEMENT.TYPE.13_20_3': 'Heggenschaar',
		'IMPLEMENT.TYPE.13_20_4': 'Clearing mand',
		'IMPLEMENT.TYPE.13_20_5': 'Hark',
		'IMPLEMENT.TYPE.13_21': 'Bladblazer',
		'IMPLEMENT.TYPE.13_22': 'Banketpers / bordenpers',
		'IMPLEMENT.TYPE.13_3': 'Sneeuwploeg - V-vorm',
		'IMPLEMENT.TYPE.13_4': 'Sneeuwschuiverblazer',
		'IMPLEMENT.TYPE.13_5': 'Gemonteerde strooier',
		'IMPLEMENT.TYPE.13_6': 'Getrokken strooier',
		'IMPLEMENT.TYPE.13_7': 'Bermmaaier',
		'IMPLEMENT.TYPE.13_8': 'Stempelmaaier',
		'IMPLEMENT.TYPE.13_9': 'Maaier',
		'IMPLEMENT.TYPE.14': 'Uitrusting voor voorlader',
		'IMPLEMENT.TYPE.14_1': 'Emmer',
		'IMPLEMENT.TYPE.14_2': 'Bak met groot volume',
		'IMPLEMENT.TYPE.14_3': 'Palletvork',
		'IMPLEMENT.TYPE.14_4': 'Balengrijper',
		'IMPLEMENT.TYPE.14_5': 'Balenvork',
		'IMPLEMENT.TYPE.14_6': 'Grijpt emmer ',
		'IMPLEMENT.TYPE.14_7': 'Werkplatform',
		'IMPLEMENT.TYPE.14_8': 'Mestvork',
		'IMPLEMENT.TYPE.15': 'Bijlagen oogsten',
		'IMPLEMENT.TYPE.15_1': 'Snijden',
		'IMPLEMENT.TYPE.15_1_1': 'Snijden standaard',
		'IMPLEMENT.TYPE.15_1_2': 'Opvouwbaar snijden',
		'IMPLEMENT.TYPE.15_2': 'Maïsplukker',
		'IMPLEMENT.TYPE.15_2_1': 'Maïsplukker standaard',
		'IMPLEMENT.TYPE.15_3': 'Maiskop',
		'IMPLEMENT.TYPE.15_4': 'GPS-bijlage',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up',
		'IMPLEMENT.TYPE.15_6': 'Vrijmaken van beslag',
		'IMPLEMENT.TYPE.15_7': 'Inlaatsysteem',
		'IMPLEMENT.TYPE.15_8': 'Opname van het zwad',
		'IMPLEMENT.TYPE.16': 'Diversen',
		'IMPLEMENT.TYPE.16_1': 'CCM stamppot',
		'IMPLEMENT.TYPE.16_2': 'Gewicht voorzijde',
		'IMPLEMENT.TYPE.16_3': 'Gewicht achter',
		'IMPLEMENT.TYPE.16_4': 'Duwend mes',
		'IMPLEMENT.TYPE.17': 'Boomgaard en wijngaard',
		'IMPLEMENT.TYPE.17_1': 'Ploeg ruimen',
		'IMPLEMENT.TYPE.17_2': 'Plantmachine',
		'IMPLEMENT.TYPE.17_3': 'Ontbladeraar',
		'IMPLEMENT.TYPE.17_4': 'Onderstam freesmachine',
		'IMPLEMENT.TYPE.18': 'Groente groeien',
		'IMPLEMENT.TYPE.18_1': 'Wortelrooier',
		'IMPLEMENT.TYPE.18_2': 'Uienrooier',
		'IMPLEMENT.TYPE.18_4': 'Bollenoogstmachine',
		'IMPLEMENT.TYPE.18_5': 'Prei-oogstmachine',
		'IMPLEMENT.TYPE.19': 'Suikerbiettechnologie',
		'IMPLEMENT.TYPE.19_1': 'Suikerbietenrooier - Bunkerrooier',
		'IMPLEMENT.TYPE.19_1_1': 'Bunkerrooier',
		'IMPLEMENT.TYPE.19_1_2': 'Overlader',
		'IMPLEMENT.TYPE.1_1': 'Ronde balenpers',
		'IMPLEMENT.TYPE.1_2': 'Vierkante balenpers',
		'IMPLEMENT.TYPE.1_3': 'Combinatie persen / wikkelen',
		'IMPLEMENT.TYPE.1_4': 'Balenwikkelaar',
		'IMPLEMENT.TYPE.1_5': 'Balenpers met hoge dichtheid',
		'IMPLEMENT.TYPE.2': 'Bodembewerking',
		'IMPLEMENT.TYPE.2_1': 'Ploeg',
		'IMPLEMENT.TYPE.2_10': 'Roterende helmstok',
		'IMPLEMENT.TYPE.2_10_1': 'Roterende frees - gemonteerd',
		'IMPLEMENT.TYPE.2_10_2': 'Rotary tiller - bevestigd',
		'IMPLEMENT.TYPE.2_11': 'Voorpakker',
		'IMPLEMENT.TYPE.2_12': 'Rol',
		'IMPLEMENT.TYPE.2_12_1': 'Roller - gemonteerd',
		'IMPLEMENT.TYPE.2_12_2': 'Roller - bevestigd',
		'IMPLEMENT.TYPE.2_13': 'Rotorkopeggen',
		'IMPLEMENT.TYPE.2_13_1': 'Rotorkopeggen - gemonteerd',
		'IMPLEMENT.TYPE.2_13_2': 'Rotorkopeggen - gemonteerd',
		'IMPLEMENT.TYPE.2_14': 'Roterende cultivator',
		'IMPLEMENT.TYPE.2_14_1': 'Roterende cultivator - gemonteerd',
		'IMPLEMENT.TYPE.2_14_2': 'Roterende cultivator - bevestigd',
		'IMPLEMENT.TYPE.2_15': 'Zaaibedcombinatie',
		'IMPLEMENT.TYPE.2_15_1': 'Zaaibedcombinatie - gemonteerd',
		'IMPLEMENT.TYPE.2_15_2': 'Zaaibedcombinatie - bijgevoegd',
		'IMPLEMENT.TYPE.2_16': 'Persen',
		'IMPLEMENT.TYPE.2_17': 'Schrapers',
		'IMPLEMENT.TYPE.2_17_1': 'Schrapers - gemonteerd',
		'IMPLEMENT.TYPE.2_17_2': 'Schrapers - bevestigd',
		'IMPLEMENT.TYPE.2_18': 'Stro-eg',
		'IMPLEMENT.TYPE.2_18_1': 'Strohalm - gemonteerd',
		'IMPLEMENT.TYPE.2_18_2': 'Strohalm - bevestigd',
		'IMPLEMENT.TYPE.2_19': 'Onkruidverdelger / hijsmachine',
		'IMPLEMENT.TYPE.2_19_1': 'Verdere cultivatoren - gemonteerd',
		'IMPLEMENT.TYPE.2_19_2': 'Verdere cultivatoren - bijgevoegd',
		'IMPLEMENT.TYPE.2_1_1': 'Gemonteerde ploeg',
		'IMPLEMENT.TYPE.2_1_2': 'Halfgedragen ploeg',
		'IMPLEMENT.TYPE.2_1_3': 'Halfgedragen ploeg (op het land)',
		'IMPLEMENT.TYPE.2_2': 'Cultivator',
		'IMPLEMENT.TYPE.2_20': 'Verdere telers',
		'IMPLEMENT.TYPE.2_2_1': 'Opbouw cultivator',
		'IMPLEMENT.TYPE.2_2_2': 'Halfgedragen cultivator',
		'IMPLEMENT.TYPE.2_3': 'Schijveneg',
		'IMPLEMENT.TYPE.2_3_1': 'Gemonteerde schijveneg',
		'IMPLEMENT.TYPE.2_3_2': 'Halfgedragen eg',
		'IMPLEMENT.TYPE.2_4': 'Compacte schijveneg',
		'IMPLEMENT.TYPE.2_4_1': 'Compacte schijveneg - gemonteerd',
		'IMPLEMENT.TYPE.2_4_2': 'Compacte schijveneg - bevestigd',
		'IMPLEMENT.TYPE.2_5': 'Diepe losser',
		'IMPLEMENT.TYPE.2_5_1': 'Diepe losmaker - gemonteerd',
		'IMPLEMENT.TYPE.2_5_2': 'Diepe losmaker - bevestigd',
		'IMPLEMENT.TYPE.2_6': 'Spitmachine',
		'IMPLEMENT.TYPE.2_6_1': 'Spitmachine - gemonteerd',
		'IMPLEMENT.TYPE.2_6_2': 'Spitmachine - bevestigd',
		'IMPLEMENT.TYPE.2_7': 'Rotorkopeg',
		'IMPLEMENT.TYPE.2_7_1': 'Roterende eg - gemonteerd',
		'IMPLEMENT.TYPE.2_7_2': 'Roterende eg - bevestigd',
		'IMPLEMENT.TYPE.2_8': 'Roterende schoffel',
		'IMPLEMENT.TYPE.2_8_1': 'Roterende schoffel - gemonteerd',
		'IMPLEMENT.TYPE.2_8_2': 'Roterende schoffel - bevestigd',
		'IMPLEMENT.TYPE.2_9': 'Reciprocatibng eg',
		'IMPLEMENT.TYPE.2_9_1': 'Roterende eg - gemonteerd',
		'IMPLEMENT.TYPE.2_9_2': 'Roterende eg - bevestigd',
		'IMPLEMENT.TYPE.3': 'Zaaimachines / planters',
		'IMPLEMENT.TYPE.3_1': 'Mechanical seederMechanische zaaimachine',
		'IMPLEMENT.TYPE.3_1_1': 'Gedragen zaaimachine',
		'IMPLEMENT.TYPE.3_1_2': 'Halfgedragen zaaimachine',
		'IMPLEMENT.TYPE.3_1_3': 'Opgezette zaaicombinatie',
		'IMPLEMENT.TYPE.3_1_4': 'Zaaimachine combinatie - bevestigd',
		'IMPLEMENT.TYPE.3_2': 'Pneumatische zaaimachine',
		'IMPLEMENT.TYPE.3_2_1': 'Gedragen zaaimachine',
		'IMPLEMENT.TYPE.3_2_2': 'Halfgedragen zaaimachine',
		'IMPLEMENT.TYPE.3_2_3': 'Opgezette zaaicombinatie',
		'IMPLEMENT.TYPE.3_2_4': 'Halfgedragen zaaicombinatie',
		'IMPLEMENT.TYPE.3_3': 'precisie mechanische zaaimachine',
		'IMPLEMENT.TYPE.3_3_1': 'Gedragen zaaimachine',
		'IMPLEMENT.TYPE.3_3_2': 'Halfgedragen zaaimachine',
		'IMPLEMENT.TYPE.3_3_3': 'Opgezette zaaicombinatie',
		'IMPLEMENT.TYPE.3_3_4': 'Halfgedragen zaaicombinatie',
		'IMPLEMENT.TYPE.3_4': 'Precisie-zaaimachine',
		'IMPLEMENT.TYPE.3_4_1': 'Gedragen zaaimachine',
		'IMPLEMENT.TYPE.3_4_2': 'Halfgedragen zaaimachine',
		'IMPLEMENT.TYPE.3_4_3': 'Opgezette zaaicombinatie',
		'IMPLEMENT.TYPE.3_4_4': 'Halfgedragen zaaicombinatie',
		'IMPLEMENT.TYPE.3_5': 'Directe zaaimachine',
		'IMPLEMENT.TYPE.3_5_1': 'Directe zaaimachine - gemonteerd',
		'IMPLEMENT.TYPE.3_5_2': 'Directe zaaimachine - bevestigd',
		'IMPLEMENT.TYPE.3_6': 'Enkele korrel diorect zaaimachine',
		'IMPLEMENT.TYPE.3_6_1': 'Eenkorrelige zaaimachine - gemonteerd',
		'IMPLEMENT.TYPE.3_6_2': 'Eenkorrelige zaaimachine - bevestigd',
		'IMPLEMENT.TYPE.3_7': 'Planter',
		'IMPLEMENT.TYPE.3_7_1': 'Plantenbak - gemonteerd',
		'IMPLEMENT.TYPE.3_7_2': 'Plantenbak - bevestigd',
		'IMPLEMENT.TYPE.3_8': 'Graszaaimachine',
		'IMPLEMENT.TYPE.3_8_1': 'Grasland zaaimachine - gemonteerd',
		'IMPLEMENT.TYPE.3_8_2': 'Grasland zaaimachine - bevestigd',
		'IMPLEMENT.TYPE.3_9': 'Voorste tank',
		'IMPLEMENT.TYPE.4': 'Strooier',
		'IMPLEMENT.TYPE.4_1': 'Gemonteerde strooier',
		'IMPLEMENT.TYPE.4_2': 'Half gemonteerde strooier',
		'IMPLEMENT.TYPE.5': 'Plant bescherming',
		'IMPLEMENT.TYPE.5_1': 'Opbouwspuit',
		'IMPLEMENT.TYPE.5_2': 'Getrokken veldspuit',
		'IMPLEMENT.TYPE.5_3': 'Onkruidverdelger / schoffel',
		'IMPLEMENT.TYPE.5_3_1': 'Schoffel - gemonteerd',
		'IMPLEMENT.TYPE.5_3_2': 'Schoffel - bevestigd',
		'IMPLEMENT.TYPE.5_4': 'Weeder',
		'IMPLEMENT.TYPE.5_4_1': 'Weeder - gemonteerd',
		'IMPLEMENT.TYPE.5_4_2': 'Weeder - bevestigd',
		'IMPLEMENT.TYPE.6': 'Mesttechnologie',
		'IMPLEMENT.TYPE.6_1': 'Mest / compoststrooier',
		'IMPLEMENT.TYPE.6_2': 'Slurry tanker',
		'IMPLEMENT.TYPE.6_2_1': 'Exacte verstrooier',
		'IMPLEMENT.TYPE.6_2_2': 'Sleepslangverdeler',
		'IMPLEMENT.TYPE.6_2_3': 'Slepende schoenstrooier',
		'IMPLEMENT.TYPE.6_2_4': 'Injector voor cultivator',
		'IMPLEMENT.TYPE.6_2_5': 'Injector van schijveneg',
		'IMPLEMENT.TYPE.6_2_6': 'Injector voor schijfsnijder',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill Injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Draaibare verdeler',
		'IMPLEMENT.TYPE.6_3': 'Drijfmest pomp',
		'IMPLEMENT.TYPE.6_4': 'Drijfmest mixer',
		'IMPLEMENT.TYPE.6_5': 'Mestcontainer',
		'IMPLEMENT.TYPE.6_6': 'Slangsysteem',
		'IMPLEMENT.TYPE.6_6_1': 'Sleepslangverdeler',
		'IMPLEMENT.TYPE.6_6_2': 'Sleepschoen distributeur',
		'IMPLEMENT.TYPE.6_6_3': 'Injector voor drijfmest',
		'IMPLEMENT.TYPE.6_6_4': 'Drijfmest cultivator',
		'IMPLEMENT.TYPE.6_6_5': 'Mestschijveneg',
		'IMPLEMENT.TYPE.6_6_6': 'Injector voor drijfmest',
		'IMPLEMENT.TYPE.6_6_7': 'Draaibare verdeler',
		'IMPLEMENT.TYPE.7': 'Irrigatietechniek',
		'IMPLEMENT.TYPE.7_1': 'rrigatie reiziger',
		'IMPLEMENT.TYPE.7_2': 'Irrigatiemachine met individuele sproeier',
		'IMPLEMENT.TYPE.8': 'Aardappelapparatuur',
		'IMPLEMENT.TYPE.8_1': 'Aardappelplanter',
		'IMPLEMENT.TYPE.8_1_1': 'Planter zonder roterende helmstok',
		'IMPLEMENT.TYPE.8_1_2': 'Plantenbak met roterende helmstok',
		'IMPLEMENT.TYPE.8_1_3': 'Pootmachine zonder aangebouwde rotorkopeg / volveld cultivator',
		'IMPLEMENT.TYPE.8_1_4': 'Plantmachine met aangebouwde rotorkopeg / cultivator',
		'IMPLEMENT.TYPE.8_2': 'Aardappelrooier - zwadmaaier',
		'IMPLEMENT.TYPE.8_3': 'Aardappelrooier - met bunker',
		'IMPLEMENT.TYPE.8_4': 'Aardappelrooier - lift',
		'IMPLEMENT.TYPE.8_5': 'Ridge voormalige',
		'IMPLEMENT.TYPE.8_6': 'scheidingsteken',
		'IMPLEMENT.TYPE.8_7': 'Roterende heuvel',
		'IMPLEMENT.TYPE.8_8': 'Loofklapper',
		'IMPLEMENT.TYPE.9': 'Graslanduitrusting',
		'IMPLEMENT.TYPE.9_1': 'Trommelmaaier',
		'IMPLEMENT.TYPE.9_1_1': 'Trommelmaaier met kneuzer',
		'IMPLEMENT.TYPE.9_1_2': 'Trommelmaaier zonder kneuzer',
		'IMPLEMENT.TYPE.9_1_3': 'Trommelmaaier met aangehechte kneuzer',
		'IMPLEMENT.TYPE.9_1_4': 'Trommelmaaier bevestigd zonder kneuzer',
		'IMPLEMENT.TYPE.9_2': 'Schijvenmaaier',
		'IMPLEMENT.TYPE.9_2_1': 'Schijvenmaaier met kneuzer',
		'IMPLEMENT.TYPE.9_2_2': 'Schijvenmaaier zonder kneuzer',
		'IMPLEMENT.TYPE.9_2_3': 'Schijvenmaaier met aangehechte kneuzer',
		'IMPLEMENT.TYPE.9_2_4': 'Schijvenmaaier bevestigd zonder kneuzer',
		'IMPLEMENT.TYPE.9_3': 'Roterende schudder',
		'IMPLEMENT.TYPE.9_3_1': 'Draaischudder / schudder aangebouwd',
		'IMPLEMENT.TYPE.9_3_2': 'Draaischudder bevestigd',
		'IMPLEMENT.TYPE.9_4': 'Zwadder',
		'IMPLEMENT.TYPE.9_4_1': 'Hark met enkele rotor',
		'IMPLEMENT.TYPE.9_4_2': 'Zwadhark met dubbele rotor (leggen van zijzwad)',
		'IMPLEMENT.TYPE.9_4_3': 'Zwadhark met dubbele rotor (centraal zwad leggen)',
		'IMPLEMENT.TYPE.9_4_4': 'Hark met vier rotoren',
		'IMPLEMENT.TYPE.9_4_5': 'Voortdurende fusie',
		'IMPLEMENT.TYPE.9_4_6': 'Roterende hark',
		'IMPLEMENT.TYPE.9_5': 'Graslandeg',
		'IMPLEMENT.TYPE.9_6': 'Weiland eg',
		'IMPLEMENT.TYPE.9_7': 'Graslandwals',
		'IMPLEMENT.TYPE.9_8': 'Bijl',
		'IMPLEMENTS': 'Werktuigen',
		'IMPLEMENTS.ALL': 'Alle werktuigen',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Sommige werktuigen konden niet worden gedeactiveerd.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Wil je echt de geselecteerde werktuigen deactiveren?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implementaties succesvol gedeactiveerd',
		'IMPLEMENTS.DELETE.FAILURE': 'Sommige werktuigen konden niet worden verwijderd.',
		'IMPLEMENTS.DELETE.QUESTION': 'Wilt u de geselecteerde werktuigen echt verwijderen?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Werktuigen zijn verwijderd',
		'IMPLEMENTS.MANAGEMENT': 'Implementeert beheer',
		'IMPLEMENTS.NO': 'Geen werktuigen',
		'IMPLEMENTS.NOT_SELECTED': 'Geen werktuigen geselecteerd',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Sommige werktuigen konden niet opnieuw worden geactiveerd.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Wil je de geselecteerde werktuigen echt opnieuw activeren?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Instrumenten met succes gereactiveerd',
		'IMPLEMENTS.SELECTED': 'Geselecteerde werktuigen',
		'IMPLEMENT_SCAN_DISABLED': 'Werktuig beacon-scan inactief',
		'IMPORT': 'importeren',
		'INACTIVE': 'Inactief',
		'INDIVIDUAL_LABELING': 'Aangepaste labels',
		'INFO': 'Informatie',
		'INTERPOLATION.MAP': 'Interpolatiekaart',
		'INTERPOLATION.MAP.SETTINGS': 'Instellingen interpolatiekaart',
		'IO_BOX_ACTIVATED': 'IOBox activeren',
		'ISOBUS.DDI.1': 'Streefwaarde voor de strooihoeveelheid Streefwaarde voor de strooihoeveelheid',
		'ISOBUS.DDI.10': 'Maximale toedieningssnelheid',
		'ISOBUS.DDI.100': 'Verontreiniging van gewassen',
		'ISOBUS.DDI.101': 'Doelbaalbreedte',
		'ISOBUS.DDI.102': 'Werkelijke waarde van baalbreedte',
		'ISOBUS.DDI.103': 'Standaard baalbreedte',
		'ISOBUS.DDI.104': 'Minimale baalbreedte',
		'ISOBUS.DDI.105': 'Maximale baalbreedte',
		'ISOBUS.DDI.106': 'Beoogde baalhoogte',
		'ISOBUS.DDI.107': 'Werkelijke waarde van baalhoogte',
		'ISOBUS.DDI.108': 'Standaard baalhoogte',
		'ISOBUS.DDI.109': 'Minimale baalhoogte',
		'ISOBUS.DDI.11': 'Aantal instelpunten per toepassingsgebied',
		'ISOBUS.DDI.110': 'Maximale baalhoogte',
		'ISOBUS.DDI.111': 'Instelpunt baalgrootte',
		'ISOBUS.DDI.112': 'Werkelijke baalgrootte',
		'ISOBUS.DDI.113': 'Standaard baalmaat',
		'ISOBUS.DDI.114': 'Minimale baalgrootte',
		'ISOBUS.DDI.115': 'Maximale baalgrootte',
		'ISOBUS.DDI.116': 'Volledige oppervlakte',
		'ISOBUS.DDI.117': 'Effectieve totale afstand',
		'ISOBUS.DDI.118': 'Ineffectieve totale afstand',
		'ISOBUS.DDI.119': 'Effectieve totale tijd',
		'ISOBUS.DDI.12': 'Werkelijke telling per toepassingsgebied',
		'ISOBUS.DDI.120': 'Ineffectieve totale tijd',
		'ISOBUS.DDI.121': 'Productdichtheid massa per volume',
		'ISOBUS.DDI.122': 'Productdichtheid Mass PerCount',
		'ISOBUS.DDI.123': 'Productdichtheid Volume per telling',
		'ISOBUS.DDI.124': 'Hulpklep schaalvergroting',
		'ISOBUS.DDI.125': 'Schaalverdeling hulpventiel intrekken',
		'ISOBUS.DDI.126': 'Hulpventielhelling strekt zich uit',
		'ISOBUS.DDI.127': 'Hulpventielhelling strekt zich omlaag uit',
		'ISOBUS.DDI.128': 'Hulpventielhelling trekt omhoog',
		'ISOBUS.DDI.129': 'Hulpventielhelling trekt omlaag',
		'ISOBUS.DDI.13': 'Standaardtelling per toepassingsdosering',
		'ISOBUS.DDI.130': 'Drempelwaarde vlotter hulpklep',
		'ISOBUS.DDI.131': 'Hulpklep Progressivity Extend',
		'ISOBUS.DDI.132': 'Hulpklep Progressiviteit Intrekken',
		'ISOBUS.DDI.133': 'Hulpklep omkeerpoorten',
		'ISOBUS.DDI.134': 'Apparaatelementcompensatie X',
		'ISOBUS.DDI.135': 'Apparaatelementcompensatie Y',
		'ISOBUS.DDI.136': 'Apparaatelementcompensatie Z',
		'ISOBUS.DDI.137': 'Capaciteit apparaatvolume',
		'ISOBUS.DDI.138': 'Massa capaciteit van het apparaat',
		'ISOBUS.DDI.139': 'Capaciteit apparaattelling',
		'ISOBUS.DDI.14': 'Minimaal aantal per toepassingsgebied',
		'ISOBUS.DDI.140': 'Instelpunt percentage toepassingsdosering',
		'ISOBUS.DDI.141': 'Werkelijke werkstatus',
		'ISOBUS.DDI.142': 'Latentie van de fysieke setpoint-tijd',
		'ISOBUS.DDI.143': 'Fysieke werkelijke waarde Tijdvertraging',
		'ISOBUS.DDI.144': 'Gierhoek',
		'ISOBUS.DDI.145': 'Rolhoek',
		'ISOBUS.DDI.146': 'Hellingshoek',
		'ISOBUS.DDI.147': 'Aantal logboeken',
		'ISOBUS.DDI.148': 'Totaal brandstofverbruik',
		'ISOBUS.DDI.149': 'Onmiddellijk brandstofverbruik per tijd',
		'ISOBUS.DDI.15': 'Maximale hoeveelheid per toepassingsgebied',
		'ISOBUS.DDI.150': 'Onmiddellijk brandstofverbruik per gebied',
		'ISOBUS.DDI.151': 'Onmiddellijke oppervlakte per tijdcapaciteit',
		'ISOBUS.DDI.153': 'Werkelijke genormaliseerde verschil Vegetatieve Index (NDVI)',
		'ISOBUS.DDI.154': 'Lengte fysiek object',
		'ISOBUS.DDI.155': 'Fysieke objectbreedte',
		'ISOBUS.DDI.156': 'Fysieke objecthoogte',
		'ISOBUS.DDI.157': 'Schakelaartype',
		'ISOBUS.DDI.158': 'Voorschriftcontrole staat',
		'ISOBUS.DDI.159': 'Aantal subeenheden per sectie',
		'ISOBUS.DDI.16': 'Instelpuntafstand Aanbrengdosering',
		'ISOBUS.DDI.160': 'Sectiecontrole-status',
		'ISOBUS.DDI.161': 'Werkelijke toestand van gecondenseerd werk (1-16)',
		'ISOBUS.DDI.162': 'Werkelijke toestand gecondenseerd werk (17-32)',
		'ISOBUS.DDI.163': 'Werkelijke toestand gecondenseerd werk (33-48)',
		'ISOBUS.DDI.164': 'Werkelijke toestand gecondenseerd werk (49-64)',
		'ISOBUS.DDI.165': 'Werkelijke toestand gecondenseerd werk (65-80)',
		'ISOBUS.DDI.166': 'Werkelijke toestand gecondenseerd werk (81-96)',
		'ISOBUS.DDI.167': 'Werkelijke toestand gecondenseerd werk (97-112)',
		'ISOBUS.DDI.168': 'Werkelijke toestand van gecondenseerd werk (113-128)',
		'ISOBUS.DDI.169': 'Werkelijke toestand van gecondenseerd werk (129-144)',
		'ISOBUS.DDI.17': 'Werkelijke toedieningssnelheid van de afstand',
		'ISOBUS.DDI.170': 'Werkelijke toestand van gecondenseerd werk (145-160)',
		'ISOBUS.DDI.171': 'Werkelijke toestand van gecondenseerd werk (161-176)',
		'ISOBUS.DDI.172': 'Werkelijke toestand van gecondenseerd werk (177-192)',
		'ISOBUS.DDI.173': 'Werkelijke toestand van gecondenseerd werk (193-208)',
		'ISOBUS.DDI.174': 'Werkelijke toestand van gecondenseerd werk (209-224)',
		'ISOBUS.DDI.175': 'Werkelijke toestand van gecondenseerd werk (225-240)',
		'ISOBUS.DDI.176': 'Werkelijke toestand gecondenseerd werk (241-256)',
		'ISOBUS.DDI.177': 'Werkelijke snijlengte',
		'ISOBUS.DDI.178': 'Elementtype-instantie',
		'ISOBUS.DDI.179': 'Werkelijke culturele praktijk',
		'ISOBUS.DDI.18': 'Standaard toedieningsdosering',
		'ISOBUS.DDI.180': 'Afstand apparaatreferentiepunt (DRP) tot grond',
		'ISOBUS.DDI.181': 'Opbrengst droge massa per gebied',
		'ISOBUS.DDI.182': 'Droge massa per tijdsopbrengst',
		'ISOBUS.DDI.183': 'Opbrengst totale droge massa',
		'ISOBUS.DDI.184': 'Referentie vochtigheid voor droge massa',
		'ISOBUS.DDI.185': 'Zaadkatoen massa per oppervlakte opbrengst',
		'ISOBUS.DDI.186': 'Lint katoen massa per oppervlakte opbrengst',
		'ISOBUS.DDI.187': 'Zaadkatoen massa per tijdopbrengst',
		'ISOBUS.DDI.188': 'Pluiskatoen massa per tijdopbrengst',
		'ISOBUS.DDI.189': 'Opbrengst totale zaadkatoenmassa',
		'ISOBUS.DDI.19': 'Minimale toedieningsdosering',
		'ISOBUS.DDI.190': 'Opbrengst totaal lint katoenmassa',
		'ISOBUS.DDI.191': 'Opkomstpercentage lint',
		'ISOBUS.DDI.192': 'Omgevingstemperatuur',
		'ISOBUS.DDI.193': 'Instelpunt productdruk',
		'ISOBUS.DDI.194': 'Werkelijke productdruk',
		'ISOBUS.DDI.195': 'Minimale productdruk',
		'ISOBUS.DDI.196': 'Maximale productdruk',
		'ISOBUS.DDI.197': 'Instelpunt pomp uitgangsdruk',
		'ISOBUS.DDI.198': 'Werkelijke pompuitgangsdruk',
		'ISOBUS.DDI.199': 'Minimale pompuitgangsdruk',
		'ISOBUS.DDI.2': 'Werkelijk volume per toepassingsgebied',
		'ISOBUS.DDI.20': 'Maximale toedieningssnelheid van de afstand',
		'ISOBUS.DDI.200': 'Maximale pompuitgangsdruk',
		'ISOBUS.DDI.201': 'Instelpunt tank roerdruk',
		'ISOBUS.DDI.202': 'Werkelijke roerdruk in de tank',
		'ISOBUS.DDI.203': 'Minimale roerdruk in de tank',
		'ISOBUS.DDI.204': 'Maximale roerdruk tank',
		'ISOBUS.DDI.205': 'SC Schakel tijd in',
		'ISOBUS.DDI.206': 'SC Uitschakeltijd',
		'ISOBUS.DDI.207': 'Windsnelheid',
		'ISOBUS.DDI.208': 'Windrichting',
		'ISOBUS.DDI.209': 'Relatieve vochtigheid',
		'ISOBUS.DDI.21': 'Instelpuntvolume per volume toepassingsdosering',
		'ISOBUS.DDI.210': 'Sky voorwaarden',
		'ISOBUS.DDI.211': 'Laatste baalvlokken per baal',
		'ISOBUS.DDI.212': 'Gemiddelde vochtigheid laatste baal',
		'ISOBUS.DDI.213': 'Gemiddelde slagen per vlok laatste baal',
		'ISOBUS.DDI.214': 'Levenslange baaltelling',
		'ISOBUS.DDI.215': 'Levenslange werkuren',
		'ISOBUS.DDI.216': 'Werkelijke baal hydraulische druk',
		'ISOBUS.DDI.217': 'Gemiddelde hydraulische druk laatste baal',
		'ISOBUS.DDI.218': 'Instelpunt Baal Compressie Plunjer Belasting',
		'ISOBUS.DDI.219': 'Werkelijke belasting van de compressieplunjer van de baal',
		'ISOBUS.DDI.22': 'Werkelijk volume per toepassingsdosering',
		'ISOBUS.DDI.220': 'Laatste baal Gemiddelde compressieplunjerbelasting van baal',
		'ISOBUS.DDI.221': 'Laatste baal aangebracht conserveermiddel',
		'ISOBUS.DDI.222': 'Tag-nummer laatste baal',
		'ISOBUS.DDI.223': 'Last Bale Mass',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Instelpunt werklengte',
		'ISOBUS.DDI.226': 'Werkelijke werklengte',
		'ISOBUS.DDI.227': 'Minimale werklengte',
		'ISOBUS.DDI.228': 'Maximale werklengte',
		'ISOBUS.DDI.229': 'Werkelijk nettogewicht',
		'ISOBUS.DDI.23': 'Standaardvolume per toepassingsdosering',
		'ISOBUS.DDI.230': 'Netto gewichtstoestand',
		'ISOBUS.DDI.231': 'Nettogewicht instelpunt',
		'ISOBUS.DDI.232': 'Werkelijk brutogewicht',
		'ISOBUS.DDI.233': 'Brutogewichtstaat',
		'ISOBUS.DDI.234': 'Minimaal brutogewicht',
		'ISOBUS.DDI.235': 'Maximaal brutogewicht',
		'ISOBUS.DDI.236': 'Thresher Engagement Totale tijd',
		'ISOBUS.DDI.237': 'Werkelijke status werkhoogte maaibord',
		'ISOBUS.DDI.238': 'Werkelijke status van de rotatiesnelheid van de kop',
		'ISOBUS.DDI.239': 'Opbrengst Hold-status',
		'ISOBUS.DDI.24': 'Minimaal volume per volume toepassingsdosering',
		'ISOBUS.DDI.240': 'Werkelijke systeemstatus (un) laden',
		'ISOBUS.DDI.241': 'Gewas temperatuur',
		'ISOBUS.DDI.242': 'Setpoint Zeefspeling',
		'ISOBUS.DDI.243': 'Werkelijke zeefvrijheid',
		'ISOBUS.DDI.244': 'Minimale zeefspeling',
		'ISOBUS.DDI.245': 'Maximale zeefvrijheid',
		'ISOBUS.DDI.246': 'Setpoint Chaffer Clearance',
		'ISOBUS.DDI.247': 'Werkelijke schuurspeling',
		'ISOBUS.DDI.248': 'Minimale schuurspeling',
		'ISOBUS.DDI.249': 'Maximale schuurspeling',
		'ISOBUS.DDI.25': 'Maximaal volume per toepassingsdosering van het volume',
		'ISOBUS.DDI.250': 'Instelpunt concave speling',
		'ISOBUS.DDI.251': 'Werkelijke concave speling',
		'ISOBUS.DDI.252': 'Minimale concave speling',
		'ISOBUS.DDI.253': 'Maximale concave speling',
		'ISOBUS.DDI.254': 'Setpoint Scheiding Ventilator Rotatiesnelheid',
		'ISOBUS.DDI.255': 'Werkelijke rotatiesnelheid van de scheidingsventilator',
		'ISOBUS.DDI.256': 'Minimale rotatiesnelheid van de scheidingsventilator',
		'ISOBUS.DDI.257': 'Maximale rotatiesnelheid van de scheidingsventilator',
		'ISOBUS.DDI.258': 'Hydraulische olietemperatuur',
		'ISOBUS.DDI.259': 'Opbrengstvertraging Negeer de tijd',
		'ISOBUS.DDI.26': 'Instelpunt massa per massa aanbrengdosering',
		'ISOBUS.DDI.260': 'Opbrengst-lead negeert de tijd',
		'ISOBUS.DDI.261': 'Gemiddelde opbrengst massa per tijd',
		'ISOBUS.DDI.262': 'Gemiddeld gewasvochtigheid',
		'ISOBUS.DDI.263': 'Gemiddelde opbrengst massa per gebied',
		'ISOBUS.DDI.264': 'Connector Pivot X-offset',
		'ISOBUS.DDI.265': 'Resterend gebied',
		'ISOBUS.DDI.266': 'Levenslange applicatie totale massa',
		'ISOBUS.DDI.267': 'Totaal aantal toepassingen in de hele levensduur',
		'ISOBUS.DDI.268': 'Levenslange opbrengst totaal volume',
		'ISOBUS.DDI.269': 'Levenslange opbrengst Totale massa',
		'ISOBUS.DDI.27': 'Werkelijke massa per toepassingsdosis',
		'ISOBUS.DDI.270': 'Levenslange opbrengst Totaal aantal',
		'ISOBUS.DDI.271': 'Levensduur totale oppervlakte',
		'ISOBUS.DDI.272': 'Levenslange effectieve totale afstand',
		'ISOBUS.DDI.273': 'Levensduur ineffectieve totale afstand',
		'ISOBUS.DDI.274': 'Levenslange effectieve totale tijd',
		'ISOBUS.DDI.275': 'Levensduur ineffectieve totale tijd',
		'ISOBUS.DDI.276': 'Levenslang brandstofverbruik',
		'ISOBUS.DDI.277': 'Levenslang gemiddeld brandstofverbruik per keer',
		'ISOBUS.DDI.278': 'Levenslang gemiddeld brandstofverbruik per gebied',
		'ISOBUS.DDI.279': 'Levenslange opbrengst totale droge massa',
		'ISOBUS.DDI.28': 'Standaard dosering voor massa per massa',
		'ISOBUS.DDI.280': 'Levenslange opbrengst Totaal zaad Katoenmassa',
		'ISOBUS.DDI.281': 'Levenslange opbrengst Totaal pluis Katoenmassa',
		'ISOBUS.DDI.282': 'Lifetime Threshing Engagement Total Time',
		'ISOBUS.DDI.283': 'Voorgesneden totaal aantal',
		'ISOBUS.DDI.284': 'Ongesneden totaal aantal',
		'ISOBUS.DDI.285': 'Levenslange voorgesneden totale telling',
		'ISOBUS.DDI.286': 'Levenslange ongesneden totale telling',
		'ISOBUS.DDI.287': 'Instelpunt voorschrijfmodus',
		'ISOBUS.DDI.288': 'Werkelijke receptmodus',
		'ISOBUS.DDI.289': 'Instelpunt werkstatus',
		'ISOBUS.DDI.29': 'Minimale dosering per massa',
		'ISOBUS.DDI.290': 'Instelpunt gecondenseerde werkstaat (1-16)',
		'ISOBUS.DDI.291': 'Instelpunt gecondenseerde werkstaat (17-32)',
		'ISOBUS.DDI.292': 'Instelpunt gecondenseerde werkstaat (33-48)',
		'ISOBUS.DDI.293': 'Instelpunt gecondenseerde werkstaat (49-64)',
		'ISOBUS.DDI.294': 'Instelpunt gecondenseerde werkstaat (65-80)',
		'ISOBUS.DDI.295': 'Instelpunt gecondenseerde werkstaat (81-96)',
		'ISOBUS.DDI.296': 'Instelpunt gecondenseerde werkstaat (97-112)',
		'ISOBUS.DDI.297': 'Instelpunt gecondenseerde werkstaat (113-128)',
		'ISOBUS.DDI.298': 'Instelpunt gecondenseerde werkstaat (129-144)',
		'ISOBUS.DDI.299': 'Instelpunt gecondenseerde werkstaat (145-160)',
		'ISOBUS.DDI.3': 'Standaardvolume per toepassingsgebied',
		'ISOBUS.DDI.30': 'Dosering van maximale massa per massa',
		'ISOBUS.DDI.300': 'Instelpunt gecondenseerde werkstaat (161-176)',
		'ISOBUS.DDI.301': 'Instelpunt gecondenseerde werkstaat (177-192)',
		'ISOBUS.DDI.302': 'Instelpunt gecondenseerde werkstaat (193-208)',
		'ISOBUS.DDI.303': 'Instelpunt gecondenseerde werkstaat (209-224)',
		'ISOBUS.DDI.304': 'Instelpunt gecondenseerde werkstaat (225-240)',
		'ISOBUS.DDI.305': 'Instelpunt gecondenseerde werkstaat (241-256)',
		'ISOBUS.DDI.306': 'Echt rotatiepunt X-offset',
		'ISOBUS.DDI.307': 'Echt rotatiepunt Y-offset',
		'ISOBUS.DDI.308': 'Werkelijk toepassingspercentage',
		'ISOBUS.DDI.309': 'Minimaal toepassingspercentage',
		'ISOBUS.DDI.31': 'Instelpuntvolume per aanbrengdosis',
		'ISOBUS.DDI.310': 'Maximaal toepassingspercentage',
		'ISOBUS.DDI.311': 'Relatief opbrengstpotentieel',
		'ISOBUS.DDI.312': 'Minimaal potentieel voor relatieve opbrengst',
		'ISOBUS.DDI.313': 'Maximaal potentieel voor relatieve opbrengst',
		'ISOBUS.DDI.314': 'Werkelijk Percentage Gewas Droge Materie',
		'ISOBUS.DDI.315': 'Gemiddeld percentage gewassen droge stof',
		'ISOBUS.DDI.316': 'Effectief totaal brandstofverbruik',
		'ISOBUS.DDI.317': 'Ineffectief totaal brandstofverbruik',
		'ISOBUS.DDI.318': 'Effectief totaal verbruik van dieseluitlaatvloeistof',
		'ISOBUS.DDI.319': 'Ineffectief totaal verbruik van dieseluitlaatvloeistof',
		'ISOBUS.DDI.32': 'Werkelijk volume per toepassingsdosis',
		'ISOBUS.DDI.320': 'Laatste geladen gewicht',
		'ISOBUS.DDI.321': 'Laatste onbeladen gewicht',
		'ISOBUS.DDI.322': 'Load Identification NumberLaad identificatienummer',
		'ISOBUS.DDI.323': 'Identificatienummer uitladen',
		'ISOBUS.DDI.324': 'Totale tijd betrokkenheid bij helikopter',
		'ISOBUS.DDI.325': 'Levenslange applicatie totaal volume',
		'ISOBUS.DDI.326': 'Setpoint Header Snelheid',
		'ISOBUS.DDI.327': 'Werkelijke snelheid maaibord',
		'ISOBUS.DDI.328': 'Minimale maaibordsnelheid',
		'ISOBUS.DDI.329': 'Maximale snelheid maaibord',
		'ISOBUS.DDI.33': 'Standaardvolume per toepassingsdosis',
		'ISOBUS.DDI.330': 'Setpoint Snelheid snijtrommel',
		'ISOBUS.DDI.331': 'Werkelijke snelheid van de snijtrommel',
		'ISOBUS.DDI.332': 'Minimale snelheid van de snijtrommel',
		'ISOBUS.DDI.333': 'Maximale snelheid van de snijtrommel',
		'ISOBUS.DDI.334': 'Bedrijfsuren sinds de laatste keer slijpen',
		'ISOBUS.DDI.335': 'Front aftakas uren',
		'ISOBUS.DDI.336': 'Uren aftakas achter',
		'ISOBUS.DDI.337': 'Levensduur frontaftakas-uren',
		'ISOBUS.DDI.338': 'Levenslange aftakas achter',
		'ISOBUS.DDI.339': 'Effectieve totale laadtijd',
		'ISOBUS.DDI.34': 'Minimaal volume per massa-toepassingsdosering',
		'ISOBUS.DDI.340': 'Effectieve totale lostijd',
		'ISOBUS.DDI.341': 'Instelpunt Graan Kernel Cracker Gap',
		'ISOBUS.DDI.342': 'Werkelijke Grain Kernel Cracker Gap',
		'ISOBUS.DDI.343': 'Minimum Grain Kernel Cracker Gap',
		'ISOBUS.DDI.344': 'Maximale Grain Kernel Cracker Gap',
		'ISOBUS.DDI.345': 'Instelpunt zwadbreedte',
		'ISOBUS.DDI.346': 'Werkelijke zwadbreedte',
		'ISOBUS.DDI.347': 'Minimale zwadbreedte',
		'ISOBUS.DDI.348': 'Maximale zwadbreedte',
		'ISOBUS.DDI.349': 'Nozzle Drift Reduction',
		'ISOBUS.DDI.35': 'Maximaal volume per aanbrengdosis',
		'ISOBUS.DDI.350': 'Functie of bedieningstechniek',
		'ISOBUS.DDI.351': 'Totaal toepassingsvolume',
		'ISOBUS.DDI.352': 'Toepassing totale massa',
		'ISOBUS.DDI.353': 'Totale toepassing van stikstof',
		'ISOBUS.DDI.354': 'Totale toepassing van ammonium',
		'ISOBUS.DDI.355': 'Totale toepassing van fosfor',
		'ISOBUS.DDI.356': 'Totale toepassing van kalium',
		'ISOBUS.DDI.357': 'Totale toepassing van droge stof',
		'ISOBUS.DDI.358': 'Gemiddelde droge opbrengst massa per tijd',
		'ISOBUS.DDI.359': 'Gemiddelde droge opbrengst massa per gebied',
		'ISOBUS.DDI.36': 'Instelpuntvolume per toepassingsdosering',
		'ISOBUS.DDI.360': 'Laatste baalgrootte',
		'ISOBUS.DDI.361': 'Dichtheid laatste baal',
		'ISOBUS.DDI.362': 'Totale lengte van de baal',
		'ISOBUS.DDI.363': 'Laatste baal droge massa',
		'ISOBUS.DDI.364': 'Werkelijke vlokgrootte',
		'ISOBUS.DDI.365': 'Setpoint Downforce-druk',
		'ISOBUS.DDI.366': 'Werkelijke downforce-druk',
		'ISOBUS.DDI.367': 'Override status verkorte sectie (1-16)',
		'ISOBUS.DDI.368': 'Override status verkorte sectie (17-32)',
		'ISOBUS.DDI.369': 'Override status verkorte sectie (33-48)',
		'ISOBUS.DDI.37': 'Werkelijk volume per toepassingsdosering',
		'ISOBUS.DDI.370': 'Override status verkorte sectie (49-64)',
		'ISOBUS.DDI.371': 'Override status verkorte sectie (65-80)',
		'ISOBUS.DDI.372': 'Override status verkorte sectie (81-96)',
		'ISOBUS.DDI.373': 'Override status gecondenseerde sectie (97-112)',
		'ISOBUS.DDI.374': 'Override status gecondenseerde sectie (113-128)',
		'ISOBUS.DDI.375': 'Condensed Section Override State (129-144)',
		'ISOBUS.DDI.376': 'Override status gecondenseerde sectie (145-160)',
		'ISOBUS.DDI.377': 'Override status gecondenseerde sectie (161-176)',
		'ISOBUS.DDI.378': 'Override status verkorte sectie (177-192)',
		'ISOBUS.DDI.379': 'Override status verkorte sectie (193-208)',
		'ISOBUS.DDI.38': 'Standaard toepassingsdosering per tijd',
		'ISOBUS.DDI.380': 'Override status verkorte sectie (209-224)',
		'ISOBUS.DDI.381': 'Status gecondenseerde sectie overschrijven (225-240)',
		'ISOBUS.DDI.382': 'Override status gecondenseerde sectie (241-256)',
		'ISOBUS.DDI.383': 'Schijnbare windrichting',
		'ISOBUS.DDI.384': 'Schijnbare windsnelheid',
		'ISOBUS.DDI.385': 'MSL atmosferische druk',
		'ISOBUS.DDI.386': 'Werkelijke atmosferische druk',
		'ISOBUS.DDI.387': 'Totale revoluties in fractionele revoluties',
		'ISOBUS.DDI.388': 'Totaal aantal revoluties in volledige revoluties',
		'ISOBUS.DDI.389': 'Setpoint Revolutions gespecificeerd als aantal per tijd',
		'ISOBUS.DDI.39': 'Minimaal volume per toepassingsdosering',
		'ISOBUS.DDI.390': 'Werkelijke omwentelingen per tijd',
		'ISOBUS.DDI.391': 'Standaardomwentelingen per tijd',
		'ISOBUS.DDI.392': 'Minimale omwentelingen per tijd',
		'ISOBUS.DDI.393': 'Maximale omwentelingen per tijd',
		'ISOBUS.DDI.394': 'Werkelijke inhoud brandstoftank',
		'ISOBUS.DDI.395': 'Werkelijke inhoud dieseluitlaatvloeistoftank',
		'ISOBUS.DDI.396': 'Setpoint Snelheid',
		'ISOBUS.DDI.397': 'Werkelijke snelheid',
		'ISOBUS.DDI.398': 'Minimale snelheid',
		'ISOBUS.DDI.399': 'Maximum snelheid',
		'ISOBUS.DDI.4': 'Minimaal volume per toepassingsgebied',
		'ISOBUS.DDI.40': 'Maximaal volume per toepassingsdosering',
		'ISOBUS.DDI.400': 'Snelheidsbron',
		'ISOBUS.DDI.401': 'Werkelijke toepassing van stikstof',
		'ISOBUS.DDI.402': 'Werkelijke toepassing van ammonium',
		'ISOBUS.DDI.403': 'Werkelijke toepassing van fosfor',
		'ISOBUS.DDI.404': 'Werkelijke toepassing van kalium',
		'ISOBUS.DDI.405': 'Werkelijke toepassing van droge stof',
		'ISOBUS.DDI.406': 'Werkelijke eiwitinhoud',
		'ISOBUS.DDI.407': 'Gemiddeld eiwitgehalte',
		'ISOBUS.DDI.408': 'Gemiddelde gewasbesmetting',
		'ISOBUS.DDI.409': 'Totaal verbruik van dieseluitlaatvloeistof',
		'ISOBUS.DDI.41': 'Instelpunt massa per tijd toedieningssnelheid',
		'ISOBUS.DDI.410': 'Onmiddellijk verbruik van dieseluitlaatvloeistof per keer',
		'ISOBUS.DDI.411': 'Onmiddellijk verbruik van dieseluitlaatvloeistof per gebied',
		'ISOBUS.DDI.412': 'Levenslang verbruik van dieseluitlaatvloeistof',
		'ISOBUS.DDI.413': 'Levenslang gemiddeld verbruik van dieseluitlaatvloeistof per tijd',
		'ISOBUS.DDI.414': 'Levenslang gemiddeld verbruik van dieseluitlaatvloeistof per gebied',
		'ISOBUS.DDI.415': 'Werkelijk zaadverdeelpercentage',
		'ISOBUS.DDI.416': 'Gemiddeld verenkelingspercentage van zaden',
		'ISOBUS.DDI.417': 'Werkelijk overslaan van zaadpercentage',
		'ISOBUS.DDI.418': 'Gemiddeld overslaan van zaadpercentage',
		'ISOBUS.DDI.419': 'Werkelijk zaad meervoudig percentage',
		'ISOBUS.DDI.42': 'Werkelijke hoeveelheid aanbrengdosis per tijd',
		'ISOBUS.DDI.420': 'Gemiddeld zaad meervoudig percentage',
		'ISOBUS.DDI.421': 'Werkelijke afwijking van de zaadafstand',
		'ISOBUS.DDI.422': 'Gemiddelde afwijking van de zaadafstand',
		'ISOBUS.DDI.423': 'Werkelijke variatiecoëfficiënt van zaadafstandspercentage',
		'ISOBUS.DDI.424': 'Gemiddelde variatiecoëfficiënt van zaadafstandspercentage',
		'ISOBUS.DDI.425': 'Instelpunt Maximaal toegestane afwijking tussen zaaigoed',
		'ISOBUS.DDI.426': 'Setpoint Downforce als Force',
		'ISOBUS.DDI.427': 'Werkelijke Downforce als Force',
		'ISOBUS.DDI.428': 'Geladen totale massa',
		'ISOBUS.DDI.429': 'Ongeladen totale massa',
		'ISOBUS.DDI.43': 'Standaard toepassingsdosering in massa per tijd',
		'ISOBUS.DDI.430': 'Levenslang geladen totale massa',
		'ISOBUS.DDI.431': 'Levenslang onbelaste totale massa',
		'ISOBUS.DDI.432': 'Instelpunt toepassingssnelheid van stikstof',
		'ISOBUS.DDI.433': 'Werkelijke toepassingssnelheid van stikstof',
		'ISOBUS.DDI.434': 'Minimale toepassingsdosering van stikstof',
		'ISOBUS.DDI.435': 'Maximale toepassingssnelheid van stikstof',
		'ISOBUS.DDI.436': 'Instelpunt toedieningssnelheid van ammonium',
		'ISOBUS.DDI.437': 'Werkelijke toedieningssnelheid van ammonium',
		'ISOBUS.DDI.438': 'Minimale toepassingsdosering van ammonium',
		'ISOBUS.DDI.439': 'Maximale toedieningssnelheid van ammonium',
		'ISOBUS.DDI.44': 'Minimale hoeveelheid aangebrachte massa per keer',
		'ISOBUS.DDI.440': 'nstelpunt toedieningssnelheid van fosfor',
		'ISOBUS.DDI.441': 'Werkelijke toepassingssnelheid van fosfor',
		'ISOBUS.DDI.442': 'Minimale toepassingsdosering van fosfor',
		'ISOBUS.DDI.443': 'Maximale toepassingssnelheid van fosfor',
		'ISOBUS.DDI.444': 'Instelpunt toedieningssnelheid van kalium',
		'ISOBUS.DDI.445': 'Werkelijke toedieningssnelheid van kalium',
		'ISOBUS.DDI.446': 'Minimale toepassingsdosering van kalium',
		'ISOBUS.DDI.447': 'Maximale toedieningssnelheid van kalium',
		'ISOBUS.DDI.448': 'Instelpunt toedieningssnelheid van droge stof',
		'ISOBUS.DDI.449': 'Werkelijke toepassingssnelheid van droge stof',
		'ISOBUS.DDI.45': 'Maximale dosering per keer in massa',
		'ISOBUS.DDI.450': 'Minimale aanbrengdosering van droge stof',
		'ISOBUS.DDI.451': 'Maximale toepassingssnelheid van droge stof',
		'ISOBUS.DDI.452': 'Geladen totaal volume',
		'ISOBUS.DDI.453': 'Totaal volume gelost',
		'ISOBUS.DDI.454': 'Levenslang geladen totaal volume',
		'ISOBUS.DDI.455': 'Levenslang onbelast totaal volume',
		'ISOBUS.DDI.456': 'Laatst geladen volume',
		'ISOBUS.DDI.457': 'Laatste onbelaste volume',
		'ISOBUS.DDI.458': 'Geladen totaal aantal',
		'ISOBUS.DDI.459': 'Totaal aantal gelost',
		'ISOBUS.DDI.46': 'Aantal instelpunten per tijd van aanbrengdosering',
		'ISOBUS.DDI.460': 'Lifetime Loaded Total Count',
		'ISOBUS.DDI.461': 'Lifetime Unloaded Total Count',
		'ISOBUS.DDI.462': 'Laatst geladen telling',
		'ISOBUS.DDI.463': 'Laatst ongeladen telling',
		'ISOBUS.DDI.464': 'Trek teller',
		'ISOBUS.DDI.465': 'Teller voor levenslange afstanden',
		'ISOBUS.DDI.466': 'Werkelijke relatieve connectorhoek',
		'ISOBUS.DDI.467': 'Werkelijk percentage inhoud',
		'ISOBUS.DDI.468': 'Bodem Sneeuw / Bevroren Conditie',
		'ISOBUS.DDI.469': 'Geschatte waterconditie in de bodem',
		'ISOBUS.DDI.47': 'Werkelijke telling per toepassingsdosering',
		'ISOBUS.DDI.470': 'Inklinking van grond',
		'ISOBUS.DDI.472': 'Instelpunt snijlengte',
		'ISOBUS.DDI.473': 'Minimale snijlengte',
		'ISOBUS.DDI.474': 'Maximale snijlengte',
		'ISOBUS.DDI.475': 'Instelpunt baal hydraulische druk',
		'ISOBUS.DDI.476': 'Minimale hydraulische baaldruk',
		'ISOBUS.DDI.477': 'Maximale hydraulische baaldruk',
		'ISOBUS.DDI.478': 'Instelpunt vlokgrootte',
		'ISOBUS.DDI.479': 'Minimale vlokgrootte',
		'ISOBUS.DDI.48': 'Standaardtelling per toepassingsdosering',
		'ISOBUS.DDI.480': 'Maximale vlokgrootte',
		'ISOBUS.DDI.481': 'Instelpunt aantal subbalen',
		'ISOBUS.DDI.482': 'Laatste baal Aantal subbalen',
		'ISOBUS.DDI.483': 'Instelpunt motortoerental',
		'ISOBUS.DDI.484': 'Werkelijk motortoerental',
		'ISOBUS.DDI.485': 'Minimaal motortoerental',
		'ISOBUS.DDI.486': 'Maximaal motortoerental',
		'ISOBUS.DDI.488': 'Percentage dieseluitlaatvloeistoftank',
		'ISOBUS.DDI.489': 'Maximale inhoud dieseluitlaatvloeistoftank',
		'ISOBUS.DDI.49': 'Minimale hoeveelheid per toepassingsdosering',
		'ISOBUS.DDI.490': 'Maximale inhoud brandstoftank',
		'ISOBUS.DDI.491': 'Brandstofpercentage',
		'ISOBUS.DDI.492': 'Totaal aantal motoruren',
		'ISOBUS.DDI.493': 'Levenslange motoruren',
		'ISOBUS.DDI.494': 'Partner-ID laatste gebeurtenis (byte 1-4)',
		'ISOBUS.DDI.495': 'Partner-ID laatste gebeurtenis (byte 5-8)',
		'ISOBUS.DDI.496': 'Partner-ID laatste gebeurtenis (byte 9-12)',
		'ISOBUS.DDI.497': 'Partner-ID laatste gebeurtenis (byte 13-16)',
		'ISOBUS.DDI.498': 'Partner-ID-type laatste gebeurtenis',
		'ISOBUS.DDI.499': 'Laatste gebeurtenis Partner-ID Fabrikant-ID-code',
		'ISOBUS.DDI.5': 'Maximaal volume per toepassingsgebied',
		'ISOBUS.DDI.50': 'Maximaal aantal toedieningssnelheid per keer',
		'ISOBUS.DDI.500': 'Laatste gebeurtenis Partner-ID apparaatklasse',
		'ISOBUS.DDI.501': 'Setpoint motorkoppel',
		'ISOBUS.DDI.502': 'Werkelijk motorkoppel',
		'ISOBUS.DDI.503': 'Minimaal motorkoppel',
		'ISOBUS.DDI.504': 'Maximaal motorkoppel',
		'ISOBUS.DDI.505': 'Rijpad controle niveau',
		'ISOBUS.DDI.506': 'Instelpunt Rijpadregelniveau',
		'ISOBUS.DDI.507': 'Volgnummer rijpad',
		'ISOBUS.DDI.508': 'Unieke A-B Guidance Reference Line ID',
		'ISOBUS.DDI.509': 'Werkelijk nummer',
		'ISOBUS.DDI.51': 'Setpoint grondbewerking diepte',
		'ISOBUS.DDI.510': 'Tracknummer aan de rechterkant',
		'ISOBUS.DDI.511': 'Tracknummer aan de linkerkant',
		'ISOBUS.DDI.512': 'Geleidingslijn Zwadbreedte',
		'ISOBUS.DDI.513': 'Afwijking begeleidingslijn',
		'ISOBUS.DDI.514': 'GNSS-kwaliteit',
		'ISOBUS.DDI.515': 'Staat rijpadcontrole',
		'ISOBUS.DDI.516': 'Overdosering van de tramlijn',
		'ISOBUS.DDI.517': 'Instelpunt Rijpad Condensed Work State 1-16',
		'ISOBUS.DDI.518': 'Werkelijke toestand verkort rijpad 1-16',
		'ISOBUS.DDI.519': 'Telling levensduur laatste baal',
		'ISOBUS.DDI.52': 'Werkelijke grondbewerking diepte',
		'ISOBUS.DDI.520': 'Werkelijke luifelhoogte',
		'ISOBUS.DDI.521': 'GNSS-installatietype',
		'ISOBUS.DDI.522': 'Totaal aantal touwbalen',
		'ISOBUS.DDI.523': 'Totaal aantal gaasbalen',
		'ISOBUS.DDI.524': 'Totaal aantal touwbalen voor het leven',
		'ISOBUS.DDI.525': 'Totaal aantal gaasbalen voor het leven',
		'ISOBUS.DDI.526': 'Werkelijke koelvloeistoftemperatuur',
		'ISOBUS.DDI.528': 'Capaciteit laatste baal',
		'ISOBUS.DDI.529': 'Setpoint Ganghoek voor grondbewerkingsschijven',
		'ISOBUS.DDI.53': 'Standaard grondbewerking diepte',
		'ISOBUS.DDI.530': 'Werkelijke ganghoek van de grondbewerkingsschijf',
		'ISOBUS.DDI.531': 'Werkelijk toegepast conserveermiddel per opbrengstmassa',
		'ISOBUS.DDI.532': 'Toegepast instelpunt conserveermiddel per opbrengstmassa',
		'ISOBUS.DDI.533': 'Standaard toegepast conserveermiddel per opbrengstmassa',
		'ISOBUS.DDI.534': 'Minimaal aangebracht conserveermiddel per massa opbrengst',
		'ISOBUS.DDI.535': 'Maximaal aangebracht conserveermiddel per opbrengst massa',
		'ISOBUS.DDI.536': 'Totaal toegepast conserveermiddel',
		'ISOBUS.DDI.537': 'Levenslang toegepast conserveermiddel',
		'ISOBUS.DDI.538': 'Gemiddeld aangebracht conserveermiddel per opbrengst massa',
		'ISOBUS.DDI.539': 'Werkelijke conserveringstankvolume',
		'ISOBUS.DDI.54': 'Minimale grondbewerkingsdiepte',
		'ISOBUS.DDI.540': 'Werkelijk niveau conserveringstank',
		'ISOBUS.DDI.541': 'Werkelijke aftakassnelheid',
		'ISOBUS.DDI.542': 'Setpoint toerental aftakas',
		'ISOBUS.DDI.543': 'Standaard aftakassnelheid',
		'ISOBUS.DDI.544': 'Minimum aftakassnelheid',
		'ISOBUS.DDI.545': 'Maximale aftakassnelheid',
		'ISOBUS.DDI.546': 'Lifetime Chopping Engagement Total Time',
		'ISOBUS.DDI.547': 'Instelpunt Baal Compressie Plunjer Belasting',
		'ISOBUS.DDI.548': 'Werkelijke belasting van de persplunjer van de baal',
		'ISOBUS.DDI.549': 'Laatste baal Gemiddelde compressieplunjerbelasting van baal',
		'ISOBUS.DDI.55': 'Maximale grondbewerkingsdiepte',
		'ISOBUS.DDI.550': 'Bodembedekker',
		'ISOBUS.DDI.551': 'Werkelijk koppel van de aftakas',
		'ISOBUS.DDI.552': 'Setpoint koppel aftakas',
		'ISOBUS.DDI.553': 'Standaard aftakaskoppel',
		'ISOBUS.DDI.554': 'Minimaal aftakaskoppel',
		'ISOBUS.DDI.555': 'Maximaal aftakaskoppel',
		'ISOBUS.DDI.556': 'Huidige weersomstandigheden',
		'ISOBUS.DDI.557': 'Setpoint elektrische stroom',
		'ISOBUS.DDI.558': 'Werkelijke elektrische stroom',
		'ISOBUS.DDI.559': 'Minimale elektrische stroom',
		'ISOBUS.DDI.56': 'Setpoint zaaidiepte',
		'ISOBUS.DDI.560': 'Maximale elektrische stroom',
		'ISOBUS.DDI.561': 'Standaard elektrische stroom',
		'ISOBUS.DDI.562': 'Setpoint Spanning',
		'ISOBUS.DDI.563': 'Standaardspanning',
		'ISOBUS.DDI.564': 'Werkelijke spanning',
		'ISOBUS.DDI.565': 'Minimale spanning',
		'ISOBUS.DDI.566': 'Maximale spanning',
		'ISOBUS.DDI.567': 'Werkelijke elektrische weerstand',
		'ISOBUS.DDI.568': 'Instelpunt elektrisch vermogen',
		'ISOBUS.DDI.569': 'Werkelijk elektrisch vermogen',
		'ISOBUS.DDI.57': 'Werkelijke zaaidiepte',
		'ISOBUS.DDI.570': 'Standaard elektrisch vermogen',
		'ISOBUS.DDI.571': 'Maximaal elektrisch vermogen',
		'ISOBUS.DDI.572': 'Minimaal elektrisch vermogen',
		'ISOBUS.DDI.573': 'Totale elektrische energie',
		'ISOBUS.DDI.574': 'Instelpunt elektrische energie per toepassingsgebied',
		'ISOBUS.DDI.575': 'Werkelijke elektrische energie per toepassingsgebied',
		'ISOBUS.DDI.576': 'Maximale elektrische energie per toepassingsgebied',
		'ISOBUS.DDI.577': 'Minimale elektrische energie per toepassingsgebied',
		'ISOBUS.DDI.578': 'Instelpunt temperatuur',
		'ISOBUS.DDI.579': 'Werkelijke temperatuur',
		'ISOBUS.DDI.58': 'Standaard zaaidiepte',
		'ISOBUS.DDI.580': 'Minimum temperatuur',
		'ISOBUS.DDI.581': 'Maximale temperatuur',
		'ISOBUS.DDI.582': 'Standaard temperatuur',
		'ISOBUS.DDI.583': 'Instelpunt frequentie',
		'ISOBUS.DDI.584': 'Werkelijke frequentie',
		'ISOBUS.DDI.585': 'Minimale frequentie',
		'ISOBUS.DDI.586': 'Maximale frequentie',
		'ISOBUS.DDI.587': 'Vorige regenval',
		'ISOBUS.DDI.588': 'Instelpuntvolume per toepassingsgebied',
		'ISOBUS.DDI.589': 'Werkelijk volume per toepassingsgebied',
		'ISOBUS.DDI.59': 'Minimale zaaidiepte',
		'ISOBUS.DDI.590': 'Minimaal volume per toepassingsgebied',
		'ISOBUS.DDI.591': 'Maximaal volume per toepassingsgebied',
		'ISOBUS.DDI.592': 'Standaardvolume per toepassingsgebied',
		'ISOBUS.DDI.593': 'Tractietype',
		'ISOBUS.DDI.594': 'Type stuurinrichting',
		'ISOBUS.DDI.595': 'Machinemodus',
		'ISOBUS.DDI.596': 'Staat van dekking laadruimte',
		'ISOBUS.DDI.597': 'Total Distance',
		'ISOBUS.DDI.598': 'Levenslange totale afstand',
		'ISOBUS.DDI.599': 'Totale afstandsveld',
		'ISOBUS.DDI.6': 'Instelpunt massa per gebied Toegepaste hoeveelheid',
		'ISOBUS.DDI.60': 'Maximale zaaidiepte',
		'ISOBUS.DDI.600': 'Levensduur totale afstand veld',
		'ISOBUS.DDI.601': 'Totale afstand straat',
		'ISOBUS.DDI.602': 'Levenslange totale afstand straat',
		'ISOBUS.DDI.603': 'Werkelijke toestand verkort rijpad (17-32)',
		'ISOBUS.DDI.604': 'Werkelijke toestand verkort rijpad (33-48)',
		'ISOBUS.DDI.605': 'Werkelijke toestand verkort rijpad (49-64)',
		'ISOBUS.DDI.606': 'Werkelijke toestand verkort rijpad (65-80)',
		'ISOBUS.DDI.607': 'S.DDI.607Werkelijke toestand verkort rijpad (81-96)',
		'ISOBUS.DDI.608': 'Werkelijke toestand verkort rijpad (97-112)',
		'ISOBUS.DDI.609': 'Werkelijke toestand verkort rijpad (113-128)',
		'ISOBUS.DDI.61': 'Instelpunt werkhoogte',
		'ISOBUS.DDI.610': 'Werkelijke toestand verkort rijpad (129-144)',
		'ISOBUS.DDI.611': 'Werkelijke toestand verkort rijpad (145-160)',
		'ISOBUS.DDI.612': 'Werkelijke toestand verkort rijpad (161-176)',
		'ISOBUS.DDI.613': 'Werkelijke toestand verkort rijpad (177-192)',
		'ISOBUS.DDI.614': 'Werkelijke toestand verkort rijpad (193-208)',
		'ISOBUS.DDI.615': 'Werkelijke toestand verkort rijpad (209-224)',
		'ISOBUS.DDI.616': 'Werkelijke toestand verkort rijpad (225-240)',
		'ISOBUS.DDI.617': 'Werkelijke toestand verkort rijpad (241-256)',
		'ISOBUS.DDI.618': 'Instelpunt rijpad gecondenseerde werkstatus (17-32)',
		'ISOBUS.DDI.619': 'Instelpunt rijpad gecondenseerde werkstatus (33-48)',
		'ISOBUS.DDI.62': 'Werkelijke werkhoogte',
		'ISOBUS.DDI.620': 'Instelpunt rijpad gecondenseerde werkstatus (49-64)',
		'ISOBUS.DDI.621': 'Instelpunt rijpad gecondenseerde werkstatus (65-80)',
		'ISOBUS.DDI.622': 'Instelpunt rijpad gecondenseerde werkstatus (81-96)',
		'ISOBUS.DDI.623': 'Instelpunt rijpad gecondenseerde werkstatus (97-112)',
		'ISOBUS.DDI.624': 'Instelpunt rijpad gecondenseerde werkstatus (113-128)',
		'ISOBUS.DDI.625': 'Instelpunt rijpad gecondenseerde werkstaat (129-144)',
		'ISOBUS.DDI.626': 'Instelpunt rijpad gecondenseerde werkstaat (145-160)',
		'ISOBUS.DDI.627': 'Instelpunt rijpad gecondenseerde werkstaat (161-176)',
		'ISOBUS.DDI.628': 'Instelpunt rijpad gecondenseerde werkstaat (177-192)',
		'ISOBUS.DDI.629': 'Instelpunt rijpad gecondenseerde werkstaat (193-208)',
		'ISOBUS.DDI.63': 'Standaard werkhoogte',
		'ISOBUS.DDI.630': 'Instelpunt rijpad gecondenseerde werkstaat (209-224)',
		'ISOBUS.DDI.631': 'Instelpunt rijpad gecondenseerde werkstatus (225-240)',
		'ISOBUS.DDI.632': 'Instelpunt rijpad gecondenseerde werkstatus (241-256)',
		'ISOBUS.DDI.634': 'Werkelijk volume per afstand Toepassing',
		'ISOBUS.DDI.635': 'Standaardhoeveelheid per afstand Toe te passen hoeveelheid',
		'ISOBUS.DDI.636': 'Minimum volume per afstand Toepassing',
		'ISOBUS.DDI.637': 'Maximaal volume per afstand',
		'ISOBUS.DDI.638': 'Ingestelde bandenspanning',
		'ISOBUS.DDI.639': 'Werkelijke bandenspanning',
		'ISOBUS.DDI.64': 'Minimale werkhoogte',
		'ISOBUS.DDI.640': 'Standaard bandenspanning',
		'ISOBUS.DDI.641': 'Minimum bandenspanning',
		'ISOBUS.DDI.642': 'Maximale bandenspanning',
		'ISOBUS.DDI.643': 'Werkelijke bandtemperatuur',
		'ISOBUS.DDI.65': 'Maximale werkhoogte',
		'ISOBUS.DDI.66': 'Instelpunt werkbreedte',
		'ISOBUS.DDI.67': 'Werkelijke werkbreedte',
		'ISOBUS.DDI.68': 'Standaard werkbreedte',
		'ISOBUS.DDI.69': 'Minimale werkbreedte',
		'ISOBUS.DDI.7': 'Werkelijke massa per toepassingsgebied',
		'ISOBUS.DDI.70': 'Maximale werkbreedte',
		'ISOBUS.DDI.71': 'Inhoud instelpuntvolume',
		'ISOBUS.DDI.72': 'Werkelijke volume-inhoud',
		'ISOBUS.DDI.73': 'Maximale inhoud van het volume',
		'ISOBUS.DDI.74': 'Massa-inhoud instelpunt',
		'ISOBUS.DDI.75': 'Werkelijke massa-inhoud',
		'ISOBUS.DDI.76': 'Maximale massa-inhoud',
		'ISOBUS.DDI.77': 'Setpoint Count Inhoud',
		'ISOBUS.DDI.78': 'Werkelijke aantal inhoud',
		'ISOBUS.DDI.79': 'Maximaal aantal inhoud',
		'ISOBUS.DDI.8': 'Standaard toepassingsdosering van massa per gebied',
		'ISOBUS.DDI.80': 'Totaal toepassingsvolume',
		'ISOBUS.DDI.81': 'Toepassing totale massa',
		'ISOBUS.DDI.82': 'Totaal aantal applicaties',
		'ISOBUS.DDI.83': 'Opbrengst per oppervlakte',
		'ISOBUS.DDI.84': 'Opbrengst massa per oppervlakte',
		'ISOBUS.DDI.85': 'Tel de opbrengst per gebied',
		'ISOBUS.DDI.86': 'Volume per tijdopbrengst',
		'ISOBUS.DDI.87': 'Massa per tijdsopbrengst',
		'ISOBUS.DDI.88': 'Tel per tijdopbrengst',
		'ISOBUS.DDI.89': 'Opbrengst totaal volume',
		'ISOBUS.DDI.9': 'Minimale massa per toepassingsgebied',
		'ISOBUS.DDI.90': 'Opbrengst totale massa',
		'ISOBUS.DDI.91': 'Opbrengst totaal aantal',
		'ISOBUS.DDI.92': 'Volume per gebied Gewasverlies',
		'ISOBUS.DDI.93': 'Gewasverlies per gebied',
		'ISOBUS.DDI.94': 'Tel per gebied gewasverlies',
		'ISOBUS.DDI.95': 'Volume per keer gewasverlies',
		'ISOBUS.DDI.96': 'Massa per keer gewasverlies',
		'ISOBUS.DDI.97': 'Tel per keer gewasverlies',
		'ISOBUS.DDI.98': 'Percentage gewasverlies',
		'ISOBUS.DDI.99': 'Gewasvochtigheid',
		'ISOBUS.DEVICE_CLASS.0': 'NonSpec',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigatie',
		'ISOBUS.DEVICE_CLASS.11': 'Transport / aanhangwagen',
		'ISOBUS.DEVICE_CLASS.12': 'Farm Yard Operations',
		'ISOBUS.DEVICE_CLASS.13': 'Aangedreven hulpapparatuur',
		'ISOBUS.DEVICE_CLASS.14': 'Speciale gewassen',
		'ISOBUS.DEVICE_CLASS.15': 'grondwerk',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sensorsystemen',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Houtoogstmachines',
		'ISOBUS.DEVICE_CLASS.2': 'Grondbewerking',
		'ISOBUS.DEVICE_CLASS.20': 'Expediteurs',
		'ISOBUS.DEVICE_CLASS.21': 'Houtladers',
		'ISOBUS.DEVICE_CLASS.22': 'Houtverwerkingsmachines',
		'ISOBUS.DEVICE_CLASS.23': 'Mulchers',
		'ISOBUS.DEVICE_CLASS.24': 'Bedrijfsvoertuigen',
		'ISOBUS.DEVICE_CLASS.25': 'Drijfmest- / mestapplicators',
		'ISOBUS.DEVICE_CLASS.26': 'Feeders / Mixers',
		'ISOBUS.DEVICE_CLASS.27': 'Onkruidverdelgers',
		'ISOBUS.DEVICE_CLASS.3': 'Secundaire grondbewerking',
		'ISOBUS.DEVICE_CLASS.4': 'Plantenbakken / zaaimachines',
		'ISOBUS.DEVICE_CLASS.5': 'Meststoffen',
		'ISOBUS.DEVICE_CLASS.6': 'Sproeiers',
		'ISOBUS.DEVICE_CLASS.7': 'Oogstmachines',
		'ISOBUS.DEVICE_CLASS.8': 'Worteloogstmachines',
		'ISOBUS.DEVICE_CLASS.9': 'Voedergewassen',
		"ISOBUS.ELEMENT_NUMBER": "Elementnummer",
		'JOB.ARCHIVE.QUESTION': 'Wil je deze vacature echt archiveren?',
		'JOB.ARCHIVE.SUCCESS': 'De taak wordt gearchiveerd',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'The job can not be displayed completely. Any information above might be outdated and is going to be recomputed.',
		'JOB.CURRENT_STATUS': 'Huidige status',
		'JOB.DELETE.QUESTION': 'Wilt u deze taak echt verwijderen? ',
		'JOB.DELETE.SUCCESS': 'Taak word verwijderd',
		'JOB.DETAILS': 'Taak details',
		'JOB.DRIVER_IMPLEMENT': 'Verwijder of wijzig bestuurder / werktuig',
		'JOB.EDIT': 'Bewerk taak',
		'JOB.REGENERATE': 'Werk opnieuw genereren',
		'JOB.REGENERATE.DRIVER': 'Update stuurprogrammagegevens',
		'JOB.REGENERATE.FIELDS': 'Veldgegevens bijwerken',
		'JOB.REGENERATE.IMPLEMENT': 'Werktuiggegevens bijwerken',
		'JOB.REGENERATE.INTRO': 'Als de factureringsgegevens voor machines, werktuigen of stuurprogramma\'s zijn gewijzigd, kunnen deze ook worden bijgewerkt.',
		'JOB.REGENERATE.LOCATIONS': 'Locatiegegevens bijwerken',
		'JOB.REGENERATE.MACHINE': 'Werk de machinegegevens bij',
		'JOB.REGENERATE.QUESTION': 'Welke gegevens worden bijgewerkt?',
		'JOB.REGENERATE.SUCCESS': 'Job zal worden hersteld',
		'JOB.SPLIT': 'Taak splitsen',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Voeg tussentijd toe',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Voor instellingen die tot op de seconde nauwkeurig zijn, kan de tijdschuifregelaar ook worden bediend met de pijltjestoetsen.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Voeg tijd (en) toe om de taak te splitsen.',
		'JOB.SPLIT.NO_CHANGE': 'Geen verandering van taak',
		'JOB.SPLIT.NO_SPLITS': 'Geen tijd (en) geselecteerd om te splitsen',
		'JOB.UPDATE': 'Functie(s) bijwerken',
		'JOB.WAITING_TIME_UNTIL_READY': 'Afhankelijk van de huidige status kan het enkele minuten duren voordat de taak volledig kan worden getoond.',
		'JOBS': 'Taken',
		'JOBS.ALL': 'Alle taken',
		'JOBS.ARCHIVE.PARTIAL': 'Sommige taken zijn archiveerd',
		'JOBS.ARCHIVE.QUESTION': 'Wilt u de geselecteerde taken echt archiveren?',
		'JOBS.ARCHIVE.SUCCESS': 'Taken worden gearchiveerd',
		'JOBS.CREATE_TASK': 'Taak maken',
		'JOBS.DELETE.QUESTION': 'Wil je de geselecteerde taken echt verwijderen? Alle gegevens van de taken worden onherroepelijk verwijderd.',
		'JOBS.DELETE.SUCCESS': 'Banen worden verwijderd',
		'JOBS.DELETED.FAILURE': 'Sommige taken konden niet worden verwijderd.',
		'JOBS.EDIT': 'Taken bewerken',
		'JOBS.EDIT.SUCCESS': 'Jobs zullen worden bewerkt',
		'JOBS.IN_TASK': 'Banen in taken',
		'JOBS.MERGE.SUCCESS': 'Banen worden samengevoegd',
		'JOBS.MERGING': 'Voeg taken samen',
		'JOBS.NO': 'Geen taken',
		'JOBS.NOT_SELECTED': 'Geen taken geselcteerd',
		'JOBS.REGENERATE': 'Genereer taken opnieuw',
		'JOBS.REGENERATE.SUCCESS': 'Taken zullen worden hersteld',
		'JOBS.SELECTED': 'Geselecteerde taken',
		'JOBS.TASK_CREATED': 'Taak succesvol aangemaakt',
		'JOBS.UPDATE.SUCCESS': 'Banen worden bijgewerkt',
		'JOBS.WITHOUT_TASK': 'Banen zonder taak',
		'JOBS.WITH_TASK': 'Banen in taak',
		'KILOMETERS': 'Kilometers',
		'LANGUAGE': 'Taal',
		'LANGUAGE.ADD': 'Taal toevoegen',
		'LANGUAGE.CODE': 'Taalcode',
		'LANGUAGE.DEFAULT': 'Standaard taal',
		'LASTNAME': 'Achternaam',
		'LAST_ONLINE': 'Laatst online',
		'LAST_UPDATED': 'Laatst bijgewerkt',
		'LATITUDE': 'Breedte',
		'LOAD.MORE': 'Meer laden',
		'LOADS': 'Ladingen',
		'LOCATION': 'Locatie',
		'LOCATION.ADD': 'Locatie toevoegen',
		'LOCATION.ADD.SUCCESS': 'Locatie succesvol toegevoegd',
		'LOCATION.DEACTIVATE.QUESTION': 'Wil je de locatie echt deactiveren?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Locatie succesvol gedeactiveerd',
		'LOCATION.DELETE.QUESTION': 'Wil je de locatie echt verwijderen?',
		'LOCATION.DELETE.SUCCESS': 'Locatie succesvol verwijderd',
		'LOCATION.DETAILS': 'Locatie details',
		'LOCATION.DRAW.START': 'Markeer de locatie nu op de kaart!',
		'LOCATION.EDIT.SUCCESS': 'Locatie succesvol bewerkt',
		'LOCATIONS': 'Beheer van locaties',
		'LOCATIONS.ALL': 'Alle locaties',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Sommige locaties konden niet worden gedeactiveerd.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Wil je de locaties echt deactiveren?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Locaties succesvol gedeactiveerd',
		'LOCATIONS.DELETE.FAILURE': 'Sommige locaties konden niet worden verwijderd.',
		'LOCATIONS.DELETE.QUESTION': 'Wil je de geselecteerde locaties echt verwijderen?',
		'LOCATIONS.DELETE.SUCCESS': 'Locaties succesvol verwijdert',
		'LOCATIONS.NO': 'Geen locaties',
		'LOCATIONS.NOT_SELECTED': 'Geen locaties geselecteerd',
		'LOCATIONS.REACTIVATE.FAILURE': 'Sommige locaties konden niet worden gereactiveerd.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Wil je de geselecteerde locaties echt opnieuw activeren?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Locaties succesvol gereactiveerd',
		'LOCATIONS.SELECTED': 'Geselecteerde locaties',
		'LOG': 'Berichtenlog',
		'LOGIN': 'Inloggen',
		'LOGIN.NOT_UNLOCKED_YET': 'Nog niet ontgrendeld?',
		'LOGIN.NO_ACCOUNT_YET': 'Nog geen account?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Wachtwoord vergeten?',
		'LOGIN.REGISTER': 'Registreren',
		'LOGIN.REMEMBER_PASSWORD': 'Onthoud wachtwoord',
		'LOGIN.UNLOCK': 'Ontsluiten',
		'LOG_OUT': 'Uitloggen',
		'LONGITUDE': 'Lengte',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Verander wachtwoord',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Voer de activeringscode in die u per e-mail heeft ontvangen.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Voer hier uw e-mailadres in.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Voeg een geldig e-mail toe',
		'MAC': 'MAC',
		'MACHINE': 'Machine',
		'MACHINE.ADD': 'Machine toevoegen',
		'MACHINE.ADD.SUCCESS': 'Machine succesvol toegevoegd',
		'MACHINE.DELETE.QUESTION': 'Wilt u de machine echt verwijderen?',
		'MACHINE.DELETE.SUCCESS': 'Machine  succesvol verwijdert ',
		'MACHINE.DETAILS': 'Machine details',
		'MACHINE.EDIT': 'Machine bewerken',
		'MACHINE.EDIT.SUCCESS': 'Machine succesvol verwijdert',
		'MACHINE.INTERVAL.ADD': 'Machine-interval toevoegen',
		'MACHINE.LIVE_STATUS': 'Machine live status',
		'MACHINE.NO': 'Geen machine',
		'MACHINE.RELOAD_POSITIONS': 'Herlaad machineposities',
		'MACHINE.STATUS': 'Machine status',
		'MACHINES': 'Machines',
		'MACHINES.ALL': 'Alle machines',
		'MACHINES.DEACTIVATE.FAILURE': 'Sommige machines konden niet worden gedeactiveerd.',
		'MACHINES.DEACTIVATE.QUESTION': 'Wilt u de geselecteerde machines echt deactiveren?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Machines succesvol gedeactiveerd',
		'MACHINES.DELETE.FAILURE': 'Sommige machines konden niet worden verwijderd.',
		'MACHINES.DELETE.QUESTION': 'Wilt u de geselecteerde machines echt verwijderen?',
		'MACHINES.DELETE.SUCCESS': 'Maschines succesvol verwijderd',
		'MACHINES.MANAGEMENT': 'Machinebeheer',
		'MACHINES.NO': 'Geen machines',
		'MACHINES.NOT_SELECTED': 'Geen machines geselecteerd',
		'MACHINES.NO_LICENSE.WARNING': 'De machine heeft geen licentie. Zonder licentie worden geen gegevens opgenomen.',
		'MACHINES.REACTIVATE.FAILURE': 'Sommige machines konden niet worden gereactiveerd.',
		'MACHINES.REACTIVATE.QUESTION': 'Wilt u de geselecteerde machines echt opnieuw activeren?',
		'MACHINES.REACTIVATE.SUCCESS': 'Machines succesvol gereactiveerd',
		'MACHINES.SELECTED': 'Geselecteerde machines',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Machine/Werktuig',
		'MAC_DEVICES': 'Apparaten aangesloten op een machine',
		'MAINTENANCE': 'Onderhoud',
		'MAINTENANCE.AMOUNT': 'Onderhoudsbedrag',
		'MAINTENANCE.PERIOD': 'Onderhoudsperiode',
		'MAKE': 'Merk',
		'MANURE': 'Mest',
		'MANURE.TYPE': 'Type mest',
		'MAP': 'Kaart',
		'MAP.SECTION': 'Kaart',
		'MAP.SECTION.CHANGE': 'Kaartfragment wijzigen',
		'MARKER.ADD': 'Voeg een nieuwe marker toe',
		'MARKER.EDIT.BORDERS': 'Grens bewerken',
		'MARKER.ENTRANCE': 'Ingang',
		'MARKER.EXIT': 'Uitgang',
		'MARKER.INFO': 'Informatie',
		'MARKER.WARN': 'Waarschuwing',
		'MAX': 'Max',
		'MAX_VALUE': 'Maximale waarde',
		'MERGE': 'Samenvoegen',
		'MESSAGES.NO': 'Geen berichten',
		'MILEAGE': 'Kilometerstand',
		'MILEAGE.INVALID': 'Kilometerstand ongeldig',
		'MIN': 'Min',
		'MIN_VALUE': 'Minimale waarde',
		'MOBILE': 'Mobiel',
		'MODE.SWITCH': 'Verander modus',
		'MODEL': 'Model',
		'MYPROFILE': 'Mijn profiel',
		'MYPROFILE.BASIC_DATA': 'Basis data',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Uw basisgegevens zijn gewijzigd',
		'NAME': 'Naam',
		'NAV.ACTIVITIES': 'Activiteiten',
		'NAV.ADMIN': 'beheerder',
		'NAV.ADMIN.DASHBOARD': 'Dashboard',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Job bekijken',
		'NAV.ADMIN.USERS': 'Gebruikersbeheer',
		'NAV.CUSTOMERS': 'Klanten',
		'NAV.DASHBOARD': 'Dashboard',
		'NAV.DATA_PREPARATION': 'Data voorbereiding',
		'NAV.EMPLOYEES': 'Werknemers',
		'NAV.ENTERPRISE': 'Onderneming',
		'NAV.FIELDS': 'Velden',
		'NAV.FILE_TRANSFER': 'ISO-taakgegevens',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Hardware instellen',
		'NAV.IMPLEMENTS': 'Werktuigen',
		'NAV.LOCATIONS': 'Locaties',
		'NAV.MACHINES': 'Machines',
		'NAV.MY_SECTION': 'Mijn sectie',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Detailhandelaar',
		'NAV.SETTINGS': 'Instellingen',
		'NAV.SETTINGS.ADAPTER': 'Adapter',
		'NAV.SETTINGS.GENERAL': 'Onderneming',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statistieken',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Vertaling bewerken',
		'NAV.TRANSLATION_MANAGEMENT': 'Vertaalbeheer',
		'NETWORK.ACCESS_TECHNOLOGY': 'Toegangstechnologie',
		'NETWORK.OPERATOR': 'Exploitant',
		'NEXT': 'De volgende',
		'NO': 'Nee',
		'NONE': 'Geen',
		'NOTICE': 'Opmerking',
		'NON_PRODUCTIVE_TIME': 'Niet-productieve tijd',
		'NON_PRODUCTIVE_TIMES': 'Niet-productieve tijden',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Kan niet worden gelezen.',
		'NO_DATA': 'Geen informatie',
		'ONLY_ON': 'Alleen op',
		'OPACITY': 'Ondoorzichtigheid',
		'OPERATING_HOURS': 'Werk uren',
		'OPERATING_HOURS.INVALID': ' Werk uren ongeldig',
		'OPERATION': 'Operatie',
		'OPERATION.NOT_SELECTED': 'Geen bewerking op veld geselecteerd.',
		'OPERATION.SELECT': 'Selecteer bewerking',
		'OPERATIONS': 'Operaties',
		'OPERATIONS.ARRIVAL': 'Aankomst',
		'OPERATIONS.CUSTOMER': 'Operaties voor klant',
		'OPERATIONS.FIELD': 'Operaties op het veld',
		'OPERATIONS.FIELDS': 'Operaties op de velden',
		'OPERATIONS.FIELD_TIME': 'Tijd op het veld',
		'OPERATIONS.GEOMETRY': 'Meetkunde',
		'OPERATIONS.LOCATION': 'Operaties op locaties',
		'OPERATIONS.LOCATIONS': 'Operaties op locaties',
		'OPERATIONS.NO': 'Geen operaties',
		'OPERATIONS.PREPARATION': 'Voorbereiding',
		'OVERRIDE.NO': 'Geen opheffing',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Per pagina',
		'PAGINATION.TOTAL': 'totaal',
		'PAGINATOR.FIRST_PAGE': 'Eerste pagina',
		'PAGINATOR.ITEMS_PER_PAGE': 'Artikelen per pagina',
		'PAGINATOR.LAST_PAGE': 'Laatste pagina',
		'PAGINATOR.NEXT_PAGE': 'Volgende pagina',
		'PAGINATOR.OF': 'van',
		'PAGINATOR.PREVIOUS_PAGE': 'Vorige pagina',
		'PARTNER_CONNECTION': 'Partnerverbinding',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Verloopt niet',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Verloopt op',
		'PASSWORD': 'Wachtwoord',
		'PASSWORD.CHANGE': 'Wachtwoord wijzigen',
		'PASSWORD.CHANGE.ACTIVATE': 'Huidig ​​wachtwoord',
		'PASSWORD.CHANGE.SUCCESS': 'wachtwoord succesvol veranderd',
		'PASSWORD.CONFIRM': 'Bevestig nieuw wachtwoord',
		'PASSWORD.LENGTH.REQUIRED': 'Het wachtwoord moet minimaal 6 tekens lang zijn',
		'PASSWORD.NEW_PASSWORD': 'Nieuw wachtwoord',
		'PASSWORD.NO_MATCH': 'Wachtwoordbevestiging komt niet overeen!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Gemiddelde prestatie',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Deze waarde houdt ook rekening met alle werkstaten, inclusief voorbereidings- en wegtijden',
		'PERFORMANCE.AVERAGE.FIELD': 'Gemiddelde prestatie (veld)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Deze waarde houdt alleen rekening met het werken aan een veld, het wachten op een veld en het inschakelen van een veld',
		'PERFORMANCE.TOTAL': 'Totale prestatie',
		'PHONE': 'Contact telefoon',
		'PHONE.INVALID': 'Telefoon ongeldig',
		'PHONE_MOBILE': 'Telefoon (mobiel)',
		'PH_VALUE': 'PH value',
		"PLANT_PROTECTANT": "Plant protectant",
		'PLAY': 'Play',
		'POSTCODE': 'Postcode',
		'PREVIOUS': 'Vorige',
		'PROCESS': 'Werkwijze',
		'PROCESSED': 'Verwerkt',
		'PROCESSED.FAILURE': 'Storing tijdens verwerking',
		'PROCESSED.SUCCESSFULL': 'Succesvol verwerkt',
		'PRODUCT': 'Product',
		'PROGRESS': 'Vooruitgang',
		'PROJECTION': 'Projectie',
		'RAW_DATA': 'Ruwe data',
		'RECEIVED.AT': 'Ontvangen op',
		'REGENERATE': 'Regenereren',
		'REGENERATE.SELECTED': 'Geselecteerde opnieuw genereren',
		'REGISTER': 'Registreren',
		'REGISTER.ALREADY_REGISTERED?': 'Al geregistreerd?',
		'REGISTER.I_ACCEPT_THE': 'Ik accepteer het',
		'RELOAD': 'Herlaad',
		'REMOVE': 'Verwijderen',
		'RENEW': 'Vernieuwen',
		'REOCURRING': 'Terugkerende',
		'REPORT': 'Rapporteer',
		'RESET': 'opnieuw zetten',
		'RESOLUTION': 'Resolutie',
		'RESTORE.DRIVER': 'Stuurprogramma herstellen',
		'RESTORE.IMPLEMENT': 'Herstellen implementeren',
		'ROAD': 'Weg',
		'ROLE': 'Rol',
		'RUNTIME_H': 'Looptijd in h',
		'SAFETY_CHECK': 'Veiligheidscontrole',
		'SATELITE': 'Satelliet',
		'SAVE': 'Opslaan',
		'SCALE.TYPE': 'Type schaal',
		'SEARCH': 'Zoeken',
		'SEASON_YEAR': 'Seizoen',
		'SEASON_YEAR.START': 'Seizoenstart',
		'SELECT.ALL': 'Selecteer alles',
		'SELECT.CLEAR': 'Selectie verwijderen',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Sensorgegevens',
		'SENSORDATA.DESCRIPTION': 'Visualisatie van sensordata',
		'SENSORDATA.SELECT_SENSOR': 'Selecteer sensor',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Werkstaatkleuren tonen',
		'SENSOR_PARAMETER': 'Sensor parameter',
		'SENSOR_PARAMETER.ADD': 'Voeg sensorparameter toe',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definieer individuele sensorparemters voor het geselecteerde werktuig.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Definieer uw individuele sensorparameter.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Individuele sensorparameter',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Sensorparameter wordt gebruikt in een andere parameterconfiguratie',
		'SENSOR_PARAMETERS': 'Sensor parameters',
		'SENSOR_PARAMETERS.NO': 'Geen sensorparameters',
		'SERIAL': 'Serienummer',
		'SETTINGS': 'Instellingen',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Uw Agrirouter-account kan worden verbonden met exatrek om gegevens te delen.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter is verbonden en klaar voor gebruik. De verbinding is geldig tot',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Verbinding met exatrek-partners',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Synchroniseer velden van 365farmnet naar exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Synchroniseer werktuigen van 365farmnet naar exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Synchroniseer machines van 365farmnet naar exatrek',
		'SETTINGS.GO_TO_FARMNET': 'GA NAAR 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'De synchronisatie van en naar 365farmnet kan alleen worden gebruikt vanuit de 365farmnet webapp',
		'SHOW': 'Tonen',
		'SHOW_DIRECTION': 'Toon routebeschrijving',
		'SHOW_EVENTS': 'Toon evenementen',
		'SHOW_FIELDS': 'Toon velden',
		'SHOW_LOCATIONS': 'Toon locaties',
		'SHOW_OFFLINE_MACHINES': 'Toon offline machines',
		'SHOW_TRACKS': 'Tracks weergeven',
		'SHOW_TRACKS_': 'Tracks weergeven',
		'SNACKBAR.DAYS': 'dagen',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Uw licentie verloopt in',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Minstens één machine is al een tijdje niet online!',
		'SORT_BY': 'Sorteer op',
		'SPEED': 'Snelheid',
		'SPEED.AVERAGE': 'Gemiddelde snelheid',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Snelheidssignaal opheffen',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Splitsen',
		'START': 'Starten',
		'STATISTICS': 'Statistics',
		'STATUS': 'Status',
		'STOP': 'Stoppen',
		'STORAGE': 'Opslag',
		'STORAGE.USB': 'USB-opslag',
		'STORAGE.USB.USED': 'Gebruikte USB-opslag',
		'STORAGE.USED': 'Gebruikte opslag',
		'SYMBOLIZATION': 'Symbolisatie',
		'TASK': 'Taak',
		'TASK.ADDABLE_JOBS': 'Bijkomende banen',
		'TASK.ADD_JOBS': 'Voeg banen toe aan een taak',
		'TASK.ARCHIVED_JOB_WARNING': 'Deze taak bevat gearchiveerde taken en wordt niet volledig weergegeven!',
		'TASK.DELETE.JOB.FAILURE': 'Een taak moet ten minste één taak bevatten!',
		'TASK.DELETE.JOB.QUESTION': 'Wil je echt baan van de taak verwijderen?',
		'TASK.DELETE.JOB.SUCCESS': 'Taak succesvol verwijderd van taak',
		'TASK.DELETE.QUESTION': 'Wilt u de taak echt verwijderen?',
		'TASK.DELETE.SUCCESS': 'Taak succesvol verwijderd',
		'TASK.EDIT': 'Taak bewerken',
		'TASK.EDIT.SUCCESS': 'Taak succesvol bewerkt',
		'TASK.EXPORT_DETAILS': 'De geselecteerde taak exporteren',
		'TASK.JOBS_TO_ADD': 'taken worden toegevoegd',
		'TASK.NEW': 'Nieuwe taak',
		'TASKS': 'Taken',
		'TASKS.NO': 'Geen taken',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) actief',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'TaskController-compatibiliteitsmodus actief',
		'TAX_ID': 'BTW-nummer',
		'TC': 'Taakcontroleur',
		'TC.ACTIVE': ' TC active ',
		'TC.TC_COMP': ' TC comp. ',
		'TERMINAL.NO': 'Geen terminal',
		'TERMINAL.TYPE': 'Terminal type',
		'TEST.SUCCESS': 'Verzoek succesvol. U ontvangt spoedig een e-mail.',
		'TIME': 'Tijd',
		'TIME.REMAINING': 'Resterende tijd',
		'TIMEZONE': 'Tijdzone',
		'TITLE': 'Vraag een testaccount aan',
		'TOKEN': 'Toegangscode',
		'TOTAL': 'Totaal',
		'TRACKS.LOADING': 'Tracks laden...',
		'TRACK.WIDTH': 'Spoorbreedte',
		'TRACK.WIDTH.NARROW': 'Smal',
		'TRACK.WIDTH.NORMAL': 'Normaal',
		'TRACK.WIDTH.WIDE': 'Breed',
		'TRACK_LENGTH': 'Track lengte',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Vertaalbaar',
		'TRANSLATABLE.ADD': 'Vertaalbaar toevoegen',
		'TRANSLATION': 'Vertaling',
		'TRANSPORT': 'Vervoer',
		'TRANSPORT/AXLES': 'Transport / Assen',
		'TRANSPORTAMOUNT_AXLES': 'Transporthoeveelheid / assen',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Type',
		'UNDO': 'Ongedaan maken',
		'UNIT': 'Eenheid',
		'UNKNOWN': 'Onbekend',
		'UNTIL': 'tot',
		'UPLOAD': 'Uploaden',
		'UPLOAD.FINISHED': 'Upload voltooid',
		'UPLOADING': 'Uploaden',
		'USER.EDIT.SUCCESS': 'Gebruiker succesvol bewerkt',
		'USERNAME': 'Gebruikersnaam',
		'USERNAME.LENGTH.REQUIRED': 'De gebruikersnaam moet minimaal 6 tekens lang zijn.',
		'USERNAME.TAKEN': 'Deze naam is al in gebruik.',
		'USERNAME.VALID.CHARS': 'De gebruikersnaam mag alleen letters, cijfers, \"-\" en \"_\" bevatten.',
		'USERROLE': 'Gebruikersrol',
		'USERSTATUS': 'Gebruikers status',
		'USER_CREATED': 'Gebruiker aangemaakt.',
		'WAITING': 'Aan het wachten',
		'WARNING': 'Waarschuwing',
		'WEEK.CURRENT': 'Deze week',
		'WEEK.NEXT': 'Volgende week',
		'WEEK.PREVIOUS': 'Vorige week',
		'WEEK.SELECTED': 'Geselecteerde week',
		'WEIGHING': 'Wegen',
		'WIDTH.INVALID': 'Breedte ongeldig',
		'WORKING_HOURS': 'Werkuren',
		'WORKING_TIME': 'Werktijd',
		'WORKING_WIDTH': 'Werkbreedte',
		'WORKSTATE': 'Werkstaat',
		'WORKSTATES': 'Werkstaten',
		'YES': 'ja',
    'NO_POSITION_MACHINE_FOUND': 'Geen positiemachine gevonden',
	}
};
